/* eslint-disable no-return-await */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-unused-expressions */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable radix */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-empty */
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-console */
/* eslint-disable react/no-unused-state */

import classnames from 'classnames';
import _cloneDeep from 'lodash/cloneDeep';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { Component } from 'react';
import { toast } from 'react-toastify';
import { v4 as uuid } from 'uuid';
import dynamic from 'next/dynamic';
import { GetSDK, NodeEventsTypes, TagEventsType, ThreeInstance, TourLoaderEventsType } from '@treedis/tour-loader';
import * as React from 'react';
//import { storage } from '@/_helpers/storage';
import sortBy from 'lodash/sortBy';
import { Agent } from '@/_models/Agent';
import { EntityType, Game } from '@/_models/Game';
import { ChapterType } from '@/_models/game/GameBook';
import { MenuType } from '@/_models/Menu';
import { SweepType } from '@/_models/Sweep';
import { CustomButtonTypeOpenAsType, Tour, TourMode, TourType } from '@/_models/Tour';
import { Avatar, AVATAR_CIRCLE_RADIUS, avatarComponentType, makeAvatarComponent } from '@/_models/virtualStaging/avatar';
import { FRFloor } from '@/_models/virtualStaging/FRFloor';
import { pointsOnCircle2D } from '@/_models/virtualStaging/helper';
import { Polygon, PolygonAction, PolygonActionAction, PolygonActionMode, PolygonActionType } from '@/_models/virtualStaging/Polygon';
import { videoRendererType } from '@/_models/virtualStaging/VideoRenderer.component';
import {
  TourImage,
  TourImageAction,
  TourImageActionType,
  TourObject,
  TourVideo,
  VSImage,
  VSInteractionType,
  VSObject,
  VSTourAsset,
  VSVideo,
  VSVideoType,
} from '@/_models/virtualStaging/VSObject';
import LoadingQueue from '@/_models/virtualStaging/LoadingQueue';
import { VSSettings } from '@/_models/virtualStaging/VSSettings';
import { Mattertag } from '@/components/util/sdk/mattertag';
import PublicAPI from '../../api/TreedisPublicDAO';
import { getDeviceFingerprint } from '../../utils';
import { CustomCookieConsent } from '../common/CookieConsent';

import * as all from '../util/all';
import { getQueryVariable, getVideoLink, fetchData } from '../util/all';

import { sendToGA, startGA } from '../util/analytic';

import DeviceManager from '../util/deviceManager';
import * as popups from '../util/popups';
import * as sdk from '../util/sdk';
import socket from '../util/socket';
import { calculateMobileHeight } from '../util/styles';
import { setErrorObserver } from '@/components/util';

import BottomBar from './regular/bottomBar/BottomBar';
import SoundControls from './regular/bottomBar/SoundControls';
import FullScreen from './regular/fullScreen/FullScreen';

import { EInfoModal } from '@/components/ticketingNew/components/InfoModal';
import SetDataToRecoil from '@/components/tour/components/SetDataToRecoil';
import GameAnalyticService from '@/components/tour/game/services/GameAnalyticService';
import LoadTourIframe from './regular/loadTourIframe/LoadTourIframe';
import { afterSweepsInit } from './afterSweepInit';
import { calculateLocation } from './calculateLocation';
import { renderButtonBg } from './renderButtonBg';

import { randomNumberId } from '@/utils/randomNumberId';
import { getIframeStyle } from '@/components/tour/getIframeStyle';
import { logoutHandler } from '@/components/tour/logoutHandler';
import { stopApp } from '@/components/tour/stopApp';
import { getUrlVariables } from '@/components/tour/getUrlVariables';
import { addPinnedVideoFunc } from '@/components/tour/addPinnedVideoFunc';
import { takePositionData } from '@/components/tour/takePositionData';
import { getVSItems } from '@/api/queries';
import CrashScreen from '@/components/tour/components/CrashScreen';
import { Tag, TagType } from '@/_models/Tag';
import LoadingProgress from '@/components/common/LoadingProgress';
import ClipScreen from './game/ClipScreen';
import { Button } from '@/units/index';
import { RegularPaths } from './game/Paths';
import { GameBookHandle } from './game/GameBookHandle';

const ExperiencePopUp = dynamic(() => import('@/components/tour/components/ExperiencePopUp'), {
  ssr: false,
});

const Qualtrics = dynamic(() => import('@/components/tour/regular/popups/Qualtrics'), {
  ssr: false,
});
const IntroScreen = dynamic(() => import('./regular/introScreen/IntroScreen'), {
  ssr: false,
});
const Sweep = dynamic(() => import('./regular/sweep/Sweep'), {
  ssr: false,
});
const Share = dynamic(() => import('./regular/share/Share'), {
  ssr: false,
});
const Login = dynamic(() => import('./regular/login/Login'), {
  ssr: false,
});
const Terms = dynamic(() => import('./regular/terms/Terms'), {
  ssr: false,
});
const Help = dynamic(() => import('./regular/help/Help'), {
  ssr: false,
});
const Ad = dynamic(() => import('./regular/ad/Ad'), {
  ssr: false,
});
const CollectLeadsForm = dynamic(() => import('./regular/collectLeads/index'), {
  ssr: false,
});
const RenderTicketingContent = dynamic(() => import('../ticketingNew/components/RenderTicketingContent'), {
  ssr: false,
});
const IntroPopup = dynamic(() => import('@/components/tour/regular/avatar/popups').then((res) => res.IntroPopup), {
  ssr: false,
});
const TicketingRouter = dynamic(() => import('../ticketingNew/router'), {
  ssr: false,
});
const Watermark = dynamic(() => import('../../units').then((res) => res.Watermark), {
  ssr: false,
});
const SketchfabPopup = dynamic(() => import('@/components/tour/regular/popups/SketchfabPopup'), {
  ssr: false,
});
const Menu = dynamic(() => import('./regular/menu/Menu'), {
  ssr: false,
});
const Minimap = dynamic(() => import('./regular/minimap/Minimap'), {
  ssr: false,
});
const Panorama = dynamic(() => import('./regular/panorama/Panorama'), {
  ssr: false,
});
const ContactPopup = dynamic(() => import('./regular/popups/Contact'), {
  ssr: false,
});
const ExternalPopup = dynamic(() => import('./regular/popups/External'), {
  ssr: false,
});

const PanoPopup = dynamic(() => import('./regular/popups/Pano'), {
  ssr: false,
});
const PathFinderPopup = dynamic(() => import('./regular/popups/pathFinder'), {
  ssr: false,
});
const TagsPopup = dynamic(() => import('./regular/popups/Tags'), {
  ssr: false,
});
const VSActionsPopup = dynamic(() => import('./regular/popups/VSActions'), {
  ssr: false,
});
const Countdown = dynamic(() => import('./regular/countdown/Countdown'), {
  ssr: false,
});
const MessengerCustomerChat = dynamic(() => import('./regular/messengerCustomerChat/MessengerCustomerChat'), {
  ssr: false,
});
const MemoizedVideo = dynamic(() => import('./regular/video/Video'), {
  ssr: false,
});
const Appointment = dynamic(() => import('./regular/appointment/Appointment'), {
  ssr: false,
});

declare global {
  interface Document {
    mozCancelFullScreen?: () => Promise<void>;
    msExitFullscreen?: () => Promise<void>;
    webkitExitFullscreen?: () => Promise<void>;
    mozFullScreenElement?: Element;
    msFullscreenElement?: Element;
    webkitFullscreenElement?: Element;
  }

  interface HTMLElement {
    msRequestFullscreen?: () => Promise<void>;
    mozRequestFullscreen?: () => Promise<void>;
    webkitRequestFullscreen?: () => Promise<void>;
  }
}

const DEFAULT_VS_SENSOR_RADIUS = 25;

export default class BaseTour extends Component<any, any> {
  ticketValidSweepsHistory = [];

  ticketTimeout = null;

  messengerQ: any = getQueryVariable(window.location.href, 'messenger');

  root: any;

  iframe: any;

  showcase: any;

  showCaseTemp: any;

  avatarNodes: Map<string, any> = new Map();

  mouseCursor: any;

  audio: any;

  currentPanorama: any;

  panoPose: any;

  tourAudio: any;

  tagAudio: any;

  sweepAudio: any;

  polygonAudio: any;

  panoramaAudio: any;

  buttonAudio: any;

  buildLink: any;

  openTagIframe: any;

  openVsObjectIframe: any;

  openVsImageIframe: any;

  openVsVideoIframe: any;

  toggleExternalPopup: any;

  pose: any = {};

  sensor: any;

  tagIcons: any[];

  floor: FRFloor = new FRFloor({
    floor: 0,
    position: null, // for shadow positioning
  });

  loadModel: any;

  moveToMPLabels: any;

  setWhiteLabel: any;

  messenger: number = parseInt(this.messengerQ === false ? '1' : this.messengerQ, 10);

  visibleTags: any = {};

  hiddenTags: any = {};

  modelNodes: any[] = [];

  shadowNode: any;

  vsObjects: Array<VSTourAsset> = [];

  isMobile: boolean = DeviceManager.isMobile();

  avatarDegree = 0;

  camera: any = null;

  isShadowEnabled = false;

  gameAnalytic: GameAnalyticService = null;

  calculateLocation: any;

  renderButtonBg: any;

  clickedElement: { id: string | number; type: EntityType };

  loadingQueue: LoadingQueue;

  constructor(props: any, tourType: TourType) {
    super(props);
    this.state = {
      iframeId: `iframe_${randomNumberId()}`,
      showcaseLoaded: false,
      showSketchfabPopup: false,
      tour: null,
      floors: [],
      allowGuestBeforeHost: false,
      changeMenu: false,
      showIntroScreen: true,
      menus: [],
      reelVideos: [],
      pinnedVideos: [],
      reel: [],
      sweeps: [],
      deprecatedSweeps: [],
      mpFloors: [],
      mpLabels: [],
      translation: {},
      tourEmail: null,
      sweepGroups: [],
      host: props.rule === 'host',
      audioOnly: props.videoType === 'audio',
      minimaps: [],
      allTags: new Map(), // Treedis and Matter tags
      interacted: false,
      selectedMinimap: 0,
      menuOpened: false,
      iframeUrl: null,
      menuOpen: false,
      overlayOn: false,
      mainPlaying: false,
      otherPlaying: true,
      videoPlaying: false,
      externalPopupOn: false,
      contactPopupOn: false,
      panoramas: [],
      polygons: [],
      agents: [],
      tagPopOn: false,
      panoPopOn: false,
      gameLockPopOn: false,
      openedLock: null,
      userAnswerForGameLock: null,
      videoChatTagPopOn: false,
      vsActionPopOn: false,
      panoramaOn: false,
      openedTag: null,
      openedPanoHotspot: null,
      openedVSAction: new TourImage(),
      externalPopupUrl: null,
      minimapOn: false,
      minimapVisible: false,
      mesurementsOn: false,
      markerPopupOn: false,
      sharePopupOn: false,
      tourPlaying: false,
      mapWalkerRotation: 0,
      reelStep: 0,
      mapWalkerX: null,
      mapWalkerY: null,
      activeSweepGroup: null,
      dominantSpeaker: null,
      // user: null,
      selectedMarker: { url: null, external: null },
      tokenRemainingTime: -1,
      tokenExpiresAt: null,
      // createdAt: null,
      // clock: false,
      ticketingOpen: false,
      activePano: null,
      appointmentsModal: false,
      appointmentsHintOn: true,
      getInTouchHintOn: true,
      MenuHintOn: true,
      lock: false,
      room: props.room,
      whiteLabelData: null,
      showHelpModal: false,
      showTermsModal: false,
      showCollectLeadsModal: false,
      activeMenu: null,
      products: new Map(),
      isProductsLoaded: false,
      tourType,
      vsSettings: new VSSettings(),
      isVSReady: false,
      containerId: 'public',
      loadingTags: true,
      game: null,
      currentFloor: null,
      panoPose: { yaw: 0, pitch: 0, hfov: 0 },
      isVSEnabled: true,
      loadedOnce: false,
      showPathFinderPopup: false,
      ticketTimeLeftMs: null,
      tourMode: null,
      experiencePopUpIsOpen: false,
      onExperienceCloseCallback: () => undefined,
      currentSweep: null,
      experiencePopUpData: null,
      closedElementPopup: true,
      isEnableNextPathLock: true,
      initialDuplicates: null,
      isChangeIframe: false,
      tourMusicWasPaused: false,
      avatar: {},
      chatParticipant: {},
      infoModalData: null,
      gameTrialErr: null,
      crashScreen: false,
      unlockedChapterIds: [],
      clickedElements: [],
    };

    this.loadingQueue = LoadingQueue.getInstance();
    this.loadingQueue.subscribe((loaded: number | boolean) => {
      if (loaded === true) {
        this.setState({ loaded: true });
      }
    });
    this.renderButtonBg = renderButtonBg.bind(this);
    this.calculateLocation = calculateLocation.bind(this);
    this.buildLink = all.buildLink.bind(this); // need this code ??
    this.openTagIframe = sdk.openTagIframe.bind(this);
    this.openVsObjectIframe = sdk.openVsObjectIframe.bind(this);
    this.openVsImageIframe = sdk.openVsImageIframe.bind(this);
    this.openVsVideoIframe = sdk.openVsVideoIframe.bind(this);
    this.loadModel = sdk.loadModel.bind(this);
    this.moveToMPLabels = sdk.moveToMPLabels.bind(this);
    this.setWhiteLabel = all.setWhiteLabel.bind(this);
    document.addEventListener('keydown', this.takePosition);
    this.toggleExternalPopup = popups.toggleExternalPopup.bind(this);
    const { room } = this.state;

    socket.on('move_avatar', (data: any) => {
      const { tour } = this.state;
      if (!tour?.enableAvatar) return;
      const avatar = this.avatarNodes.get(data.avatarId);

      // Is the avatar moving into my sweep? (sweep id...)
      // if it does, use relative position, avatar.relative
      const [myX, myZ] = pointsOnCircle2D(AVATAR_CIRCLE_RADIUS, 180 + this.avatarDegree, data?.pose?.position?.x, data.pose?.position?.z);
      const [x, z] = pointsOnCircle2D(AVATAR_CIRCLE_RADIUS, data.degree, myX, myZ);

      if (avatar) {
        avatar[0].obj3D.position.set(x, data.pose.position.y, z);
        avatar[0].obj3D.rotation.set(data.pose.rotation._x, data.pose.rotation._y, data.pose.rotation._z);
        avatar[0].obj3D.quaternion.set(data.pose.quaternion._x, data.pose.quaternion._y, data.pose.quaternion._z, data.pose.quaternion._w);
        avatar[0].obj3D.children[0]?.rotation.set(0, Math.PI, 0);
      }
    });

    socket.on('move_avatar_face', (data: any) => {
      const { tour } = this.state;
      if (!tour?.enableAvatar) return;
      const avatar = this.avatarNodes.get(data.avatarId);
      if (avatar) {
        avatar[1].updateFromResults(data.pose);
      }
    });

    socket.on('all_users', (users: any) => {
      const { tour } = this.state;
      if (tour.enableAvatar) {
        users.forEach((user) => {
          if (user.socketId !== socket.id) {
            this.addAvatar(user);
          }
        });
      }
    });

    socket.on('avatar_config', async (data: any) => {
      console.log('YOUR DEGREE', data.degree);
      this.avatarDegree = data.degree;
    });

    socket.on('user_leave', async (data: any) => {
      const { tour } = this.state;
      if (tour?.enableAvatar) {
        await this.onRemoveAvatar(data.avatarId);
      }
    });

    socket.on('move', (pose: any) => {
      if (this.state.lock) {
        this.moveToSweepIO(pose);
      }
    });

    if (room) {
      socket.on('menu', (menu: any) => {
        this.loadModel(menu.name, menu.url, menu.type);
      });

      socket.on('tag', (tag: string) => {
        if (this.state.lock) {
          this.moveToTagIO(tag);
        }
      });

      socket.on('lock', (_lock: boolean) => {
        if (this.state.lock !== _lock) {
          this.setState({ lock: _lock });
        }
      });

      socket.on('close-tag', () => {
        this.setState({ tagPopOn: false });
      });
      socket.on('close-pano-pop', () => {
        this.setState({ panoPopOn: false });
      });

      socket.on('toggle-pano', (data: any) => {
        this.setState(data);
      });
      socket.on('move-pano', (data: any) => {
        this.setState({
          panoPose: data.panoPose,
          activePano: data.currentPanorama.id,
        });
      });
      socket.on('pano-hotspot-click', (data: any) => {
        this.setState({ panoramaOn: false, activePano: null }, () => {
          this.getTour({
            id: data.id,
            changeMenu: data.changeMenu,
            changeMinimap: data.changeMinimap,
            changePanorama: data.changePanorama,
            url: data.url,
            tourData: props.tourData,
          });
        });
      });
    }

    socket.on('disconnect', (reason) => {
      console.error(`Socket disconnected`, reason);
    });

    socket.io.on('reconnect', () => {
      console.log('Reconnecting socket.. enabling avatar again');
      this.initAvatar().catch((e: any) => {
        console.error('Error enabling avatar', e);
      });
    });

    window.addEventListener('beforeunload', () => logoutHandler({ ticket: this.state?.tour?.ticket, ticketingOrderedTicket: this.state.ticketing?.ticketingOrderedTicket }));
    calculateMobileHeight();
    window.addEventListener('resize', calculateMobileHeight);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', calculateMobileHeight);
  }

  getCameraRotation = async () => {
    // TODO: pass in props this.camera, not the function
    return {
      rotation: this.camera?.camera.rotation,
      quaternion: this.camera?.camera.quaternion,
    };
  };

  renderCrashScreen = () => (
    <CrashScreen show={this.state.crashScreen} backgroundImage={`${process.env.REACT_APP_AWS}/tours/${this.state.tour?.id}/images/${this.state.tour?.mainImage}`} />
  );

  showTicketTimeIsOutPopup = () => {
    this.setState({
      infoModalData: {
        mode: EInfoModal.timeIsUp,
        onRequestClose: () => {
          stopApp();
        },
      },
    });
  };

  showTicketRestrictedAreaPopup = ({ sweepThatCauseTicketRestriction, reelThatCauseTicketRestriction }: any) => {
    this.setState({
      infoModalData: {
        mode: EInfoModal.restrictedArea,
        onRequestClose: () => {
          if (sweepThatCauseTicketRestriction) this.goToPreviousValidSweep();
        },
        sweepThatCauseTicketRestriction,
        reelThatCauseTicketRestriction,
      },
    });
  };

  goToPreviousValidSweep() {
    if (this.ticketValidSweepsHistory?.length) {
      const THREE = ThreeInstance.get();
      this.moveToSweep(this.ticketValidSweepsHistory[this.ticketValidSweepsHistory.length - 1], new THREE.Euler());
    } else {
      stopApp();
    }
  }

  ticketUpdateSweepLoc = (nextSweep: string) => {
    if (this.state.tour?.ticket && this.state?.ticketing?.ticketingOrderedTicket?.ticketType === 'tourByYourself') {
      const { ticketingTourTicket } = this.state.ticketing;
      const allowedSweeps = ticketingTourTicket.selectedSweeps ? ticketingTourTicket.selectedSweeps[this.state.tour?.slug] : [];
      if (allowedSweeps.includes(nextSweep)) {
        this.ticketValidSweepsHistory.push(nextSweep);
      } else {
        this.showTicketRestrictedAreaPopup({ sweepThatCauseTicketRestriction: nextSweep });
      }
    }
  };

  onPlayClick = () => {
    const { tour, showIntro } = this.state;
    // experience doesn't trigger showcaseLoaded
    // if (!showcaseLoaded) return;
    this.tourAudio = null;
    if (showIntro) {
      this.setState({ showIntroScreen: false });
    } else {
      this.setState({ showIntroScreen: false, forcePlayGameIntro: true }, () => {
        this.processTourMusic(tour);
      });
    }

    sendToGA('event', {
      eventCategory: 'IntroScreen',
      eventAction: 'click',
      eventLabel: 'introButton',
    });
  };

  handleCollectLeadsSubmit = async (data: any) => {
    const { tour, tourEmail } = this.state;
    await PublicAPI.sendEmail({
      data: {
        to: (tourEmail && tourEmail.leadForms) || (tour.client && tour.client.email),
        params: Object.assign(data, {
          tour: tour.title,
          userId: tour.userId,
          link: window.location.href,
        }),
      },
    });
    this.loadData(tour);
    this.setState({
      showCollectLeadsModal: false,
    });
  };

  onTicketLoginSuccess = (tour: any, ticketing: any) => {
    const { ticketingOrderedTicket, ticketingTourTicket } = ticketing;
    const ticketLimitMs = ticketingTourTicket.duration * 60 * 1000;
    const ticketSpentFromLogin = Number(new Date(ticketingOrderedTicket.loginDate)) ? Date.now() - Number(new Date(ticketingOrderedTicket.loginDate)) : 0;
    const ticketTimeLeft = ticketLimitMs - ticketSpentFromLogin;

    // set time is up timeout with popup
    if (ticketTimeLeft > 0) {
      toast.success('logged in');
      setTimeout(this.showTicketTimeIsOutPopup, ticketTimeLeft);
      this.setState({
        ticketTimeLeftMs: ticketTimeLeft,
        ticketingOpen: false,
        tour,
        ticketing,
      });
      this.loadData(tour);
      this.setWhiteLabel(tour);
      socket.emit('ticketing_login', { ticketingOrderedTicket, deviceId: getDeviceFingerprint(), reel: tour.slug });
    } else {
      toast.error('wrong ticket time left');
      this.showTicketTimeIsOutPopup();
    }
  };

  handleTicketingReel = (reel: any) => {
    try {
      if (this.state.ticketing && reel.type === 'treedis') {
        const url = new URL(reel.url);
        const urlPathnameArr = url.pathname.split('/');
        if (urlPathnameArr[1] === 'tour') socket.emit('ticketing_reel', { reel: urlPathnameArr[2] });
      }
    } catch (err) {
      console.warn('handleTicketingReel', err);
    }
  };

  setParentState(attr: any, val: any) {
    this.setState({ [attr]: val });
  }

  getTour = async ({
    id,
    changeMenu = true,
    changeMinimap = true,
    changePanorama = true,
    url = null,
    hideIntroScreen = false,
    tourData,
  }: {
    id: string;
    changeMenu?: boolean;
    changeMinimap?: boolean;
    changePanorama?: boolean;
    url?: any | null;
    hideIntroScreen?: boolean;
    tourData?: any;
  }) => {
    this.setState({ showcaseLoaded: !changeMenu });
    try {
      this.loadingQueue.setLoadingQueueProgress(90, 100);

      const data =
        tourData ||
        (await PublicAPI.getTour({
          data: {
            id,
            mode: this.state.tourType,
            excludeTranslation: true,
          },
        }));
      this.loadingQueue.setLoadingQueueProgress(85, 100);

      if (!data.tour) {
        toast.error("Couldn't find this tour in our databases");
        return;
      }

      this.setWhiteLabel(data.tour);
      this.initTourInfo(data.tour.id);

      // TODO: this is insecure, fix it properly.
      if (data.ticketing && !this.state.iframeUrl) {
        const tour = new Tour(data.tour);
        const tGen = data?.ticketing?.ticketingGeneral;
        // if (this.state.game) this.loadData(data.tour);
        this.setState({
          tour,
          ticketingOpen: true,
          ticketing: { ...data.ticketing, ticketingGeneral: tGen?.length ? tGen[0] : tGen },
          tourLoaded: true,
        });
      } else if (data.tour.collectLeads && !this.state.iframeUrl) {
        const tour = new Tour(data.tour);
        this.setState({ tour, showCollectLeadsModal: true });
      } else {
        if (url) {
          if (data.ticketing && this.state.iframeUrl) {
            // TODO: check a more secure way to handle this case. People can just add "ticket" the the href and hack the system
            const ticket = new URLSearchParams(window.location.search).get('ticket');
            if (!ticket || ticket.length === 0) window.location.href = window.location.href.replace(/tour.*/, `tour/${data.tour.slug}`);
          }

          // Support for matterport->treedis->matterport
          const iframeId = getQueryVariable(this.state.iframeUrl, 'm');
          const s = getQueryVariable(url, 's');
          const x = getQueryVariable(url, 'x');
          const y = getQueryVariable(url, 'y');

          // eslint-disable-next-line eqeqeq
          if (iframeId == data.tour.matterId && s && x && y) {
            // We move inside the tour
            const menuOpenForDevice = this.state.tourType === TourType.Regular && !!(DeviceManager.isMobile() ? data.tour.menuAlwaysOpenMobile : data.tour.menuAlwaysOpenDesktop);
            this.setState({
              menuOpen: changeMenu ? menuOpenForDevice : this.state.menuOpen,
              showcaseLoaded: true,
            });

            if (this.showcase.App.Phase.PLAYING.includes(this.state.appState)) {
              await this.moveToSweep(String(s), { x: parseFloat(x), y: parseFloat(y) });
            }

            return;
          }
          if (iframeId !== data.tour.matterId) {
            this.setState({ isChangeIframe: true });
          }

          if (hideIntroScreen) {
            data.tour.introScreen = null;
          }
        }

        this.loadData(data.tour, changeMenu, changeMinimap, changePanorama, url);
      }
    } catch (err) {
      console.error(err.message);
    }
  };

  initTourInfo = (id: number) => {
    fetchData(`public/getTranslations/${id}`, 'GET')
      .then((data) => {
        this.setState({ translation: data.translations });
      })
      .catch((err) => {
        console.error(err.message);
      });

    fetchData(`public/getEmails/${id}`, 'GET')
      .then((data) => {
        this.setState({ tourEmail: data.emails });
      })
      .catch((err) => {
        console.error(err.message);
      });
  };

  getTagIconId = (tag) => {
    const iconName = tag.iconFile || tag.icon;
    const iconSid = tag.sid;
    if (iconName && iconSid) {
      return `${iconName}_${iconSid}`;
    }
    return null;
  };

  addMattertag = async (tag: any) => {
    const sid = null;
    try {
      let media;
      if (tag.media) {
        media = {
          src: tag.media.src,
          type: `mattertag.media.${tag.media.type.toLowerCase()}`,
        };
      }

      const rgb = all.hexToRgb(tag.iconColor);
      const addDetails = {
        label: tag.title,
        description: tag.description,
        anchorPosition: {
          x: tag.positionX,
          y: tag.positionY,
          z: tag.positionZ,
        },
        stemVector: {
          x: tag.stemVectorX,
          y: tag.stemVectorY,
          z: tag.stemVectorZ,
        },
        color: {
          r: rgb.r / 255,
          g: rgb.g / 255,
          b: rgb.b / 255,
        },
        iconId: this.getTagIconId(tag),
        media,
      };

      const addRes = await this.showcase.Mattertag.add(addDetails).catch((e) => {
        console.error(e);
      });

      if (addRes && addRes[0]) {
        // eslint-disable-next-line prefer-destructuring
        tag.sid = addRes[0];
        await this.editTagMedia(tag);
        return tag.sid;
      }
    } catch (err) {
      console.error(err);
    }
    return sid;
  };

  registerIcon = async ({ iconId, url }) => {
    await this.showcase.Mattertag.registerIcon(iconId, url).catch((e) => {
      console.error(e);
    });
  };

  editTagMedia = async (tag: any) => {
    const { tour } = this.state;
    if (!tag) return;
    if (tag.opacity !== null && typeof tag.opacity === 'number') {
      await this.showcase.Mattertag.editOpacity(tag.sid, tag.opacity / 100).catch((e) => {
        console.error(e);
      });
    }
    const label = tag.mpTitle ? tag.title : '';
    const { description } = tag;

    if (tag.embedMedia && tag.enabled) {
      let media = null;
      const size = this.isMobile
        ? { w: tag.widthMobile || 300, h: tag.heightMobile || 400 }
        : {
            w: tag.width || 700,
            h: tag.height || 500,
          };
      if (tag.type === TagType.Image) {
        media = {
          type: this.showcase.Mattertag.MediaType.PHOTO,
          src: `${process.env.REACT_APP_AWS}/tours/${tour?.id}/tags/${tag.url}`,
        };
      }

      if (tag.type === TagType.Gallery) {
        // TODO
      }

      if (tag.type === TagType.Video) {
        media = { type: this.showcase.Mattertag.MediaType.VIDEO, src: tag.url };
      }

      if (tag.type === TagType.Iframe) {
        this.showcase.Mattertag.injectHTML(tag.sid, `<iframe src=${tag.url} style="width: 100%; height: 100vh"></iframe>`, { size });
      }

      if (tag.type === TagType.Text) {
        this.showcase.Mattertag.injectHTML(tag.sid, `<div>${tag.text}</div>`, {
          size,
        });
      }
      await this.showcase.Mattertag.editBillboard(tag.sid, {
        label,
        description,
        media,
      }).catch(console.error);
    } else {
      await this.showcase.Mattertag.editBillboard(tag.sid, {
        label,
        description,
      }).catch(console.error);
    }

    await this.showcase.Mattertag.preventAction(tag.sid, {
      // prevent opening: true/false
      opening: !tag.mpTooltip,
      navigating: !tag.mpNavigation,
    }).catch(console.error);
  };

  editMattertag = async (tag: any) => {
    try {
      const iconId = this.getTagIconId(tag);
      if (iconId) {
        await this.showcase.Mattertag.editIcon(tag.sid, iconId).catch((e) => {
          console.error(e);
        });
      } else {
        await this.showcase.Mattertag.resetIcon(tag.sid).catch((e) => {
          console.error(e);
        });
      }

      if (tag.iconColor && /#\w*/i.test(tag.iconColor)) {
        const rgb = all.hexToRgb(tag.iconColor);
        await this.showcase.Mattertag.editColor(tag.sid, {
          r: rgb.r / 255,
          g: rgb.g / 255,
          b: rgb.b / 255,
        }).catch(console.error);
      }
      await this.editTagMedia(tag);
    } catch (err) {
      console.error(err);
    }
  };

  initTags = async (_tags: Array<any>) => {
    try {
      if (!_tags.length) {
        this.setState({ loadingTags: false });
        return _tags;
      }
      const { allTags } = this.state;
      const loadedMattertags = Mattertag.getMatterTags();

      const tagsSize = _tags.length;
      this.tagIcons = [];

      for (let i = 0; i < tagsSize; i += 1) {
        const tag = _tags[i];
        const iconId = this.getTagIconId(tag);
        if (iconId && !this.tagIcons.some((icon) => icon?.iconId === iconId)) {
          let tagIconUrl;
          if (tag.iconFile) {
            if (tag.iconFile.startsWith('http')) {
              tagIconUrl = `${tag.iconFile}`;
            } else {
              tagIconUrl = `${process.env.REACT_APP_AWS}/tours/${tag.tourId}/tags/icons/${tag.iconFile}`;
            }
          } else if (tag.icon) {
            tagIconUrl = `${process.env.REACT_APP_DOMAIN || 'http://localhost:5030'}/v1/public/icons/${tag.icon}?hex=${encodeURIComponent(tag.iconColor)}&circle=${
              tag.whiteCircle
            }`;
          }

          this.tagIcons.push({
            iconId,
            url: tagIconUrl,
          });
        }
      }

      const registerIconsPromises = this.tagIcons.map(this.registerIcon);
      await Promise.all(registerIconsPromises);

      const processTags = async (tag: any) => {
        const editedTag = { ...tag };
        if (editedTag.modifiedTag && loadedMattertags.has(tag.sid)) {
          // modified mp tag
          await this.editMattertag(editedTag);
          allTags.set(editedTag.sid, editedTag);

          return;
        }
        if (!editedTag.modifiedTag && !loadedMattertags.has(tag.sid)) {
          // pure treedis tag
          const foundAddTag = Array.from(allTags, ([, value]: any) => value).find((item: { id: number; added: boolean }) => item.id === tag.id && item.added);
          if (!foundAddTag) {
            editedTag.defaultSid = editedTag.sid;
            allTags.delete(editedTag.sid);
            editedTag.sid = await this.addMattertag(editedTag);
            editedTag.added = true;
          }
        }

        allTags.set(editedTag.sid, editedTag);
      };

      const tagsTimeout = (t) =>
        new Promise<void>((resolve) => {
          setTimeout(async () => {
            await processTags(t);
            resolve();
          }, 1);
        });

      const tagsLoop = async () => {
        for (let i = 0; i < _tags.length; i += 1) {
          const t = _tags[i];
          // eslint-disable-next-line no-await-in-loop
          await tagsTimeout(t);
        }
      };

      await tagsLoop();

      // This is gonna block the thread:
      // const promises = _tags.map(processTags);
      // const mappedTags = await Promise.all(promises);

      return allTags;
    } catch (err) {
      console.error(err);
    }
  };

  toggleVisibleTags = (tags: any, isVisible: boolean) => {
    tags.forEach(async (_tag: any) => {
      const { sid, mpTooltip, mpNavigation } = _tag;

      // We shouldn't re-toggle tags that are already visible, waste of sources.
      if (isVisible && this.visibleTags[sid]) return;
      if (isVisible) this.visibleTags[sid] = true;
      else this.visibleTags[sid] = false;

      if (!isVisible && this.hiddenTags[sid]) return;
      if (!isVisible) this.hiddenTags[sid] = true;
      else this.hiddenTags[sid] = false;

      if (_tag.type === TagType.Music && !isVisible) {
        const src = `${process.env.REACT_APP_AWS}/tours/${this.state.tour.id}/tags/${_tag.url}`;
        if (this.tagAudio && this.tagAudio.src === src) {
          this.tagAudio.pause();
          this.tagAudio.src = '';
        }
      }
      await this.showcase.Mattertag.editOpacity(sid, isVisible ? _tag.opacity / 100 : 0).catch((e) => console.error(e));
      await this.showcase.Mattertag.editPosition(sid, {
        anchorPosition: {
          x: _tag.positionX,
          y: _tag.positionY,
          z: _tag.positionZ,
        },
        stemVector: {
          x: isVisible ? _tag.stemVectorX : 0,
          y: isVisible ? _tag.stemVectorY : 0,
          z: isVisible ? _tag.stemVectorZ : 0,
        },
        floorIndex: _tag.floor,
      }).catch((e) => console.error(e));

      const preventOpening = isVisible ? !mpTooltip : true;
      const preventNavigating = isVisible ? !mpNavigation : true;
      await this.showcase.Mattertag.preventAction(sid, {
        opening: preventOpening,
        navigating: preventNavigating,
      }).catch((e) => console.error(e));
    });
  };

  filterTags = () => {
    const { activeSweepGroup, sweepGroups, allTags, tourType, loadingTags } = this.state;
    if (TourType.Game === tourType) return; // we skip filtering if it's game
    if (loadingTags) return;
    const activeGroup = Array.isArray(sweepGroups) ? sweepGroups.find((sg: any) => sg.id === activeSweepGroup && sg.hideTags) : false;
    const tagsToRemove: any = [];
    const tagsToInit: any = [];

    if (allTags && allTags.size) {
      allTags.forEach((tag: any) => {
        const found = activeGroup?.tags?.find((item) => item.tagSid === tag.sid || item.tagSid === tag.defaultSid);
        if (found || !activeGroup) {
          tagsToInit.push(tag);
        } else {
          tagsToRemove.push(tag);
        }
      });
    }

    this.toggleVisibleTags(tagsToRemove, false);
    this.toggleVisibleTags(tagsToInit, true);
  };

  handleToggleMusic = async (forceMusicPause = true) => {
    try {
      if (this.tourAudio) {
        await this.pauseAllAudio('tourAudio');
        if (this.tourAudio.paused) {
          if (this.state.vsAudio) {
            this.state.vsAudio.component.toggleMute();
            this.state.vsAudio.btn.setActive(true);
            this.setState({ vsAudio: null });
          }
          await this.tourAudio.play();
          this.setState({ mainPlaying: true, otherPlaying: false, forceMusicPause: false });
        } else {
          await this.tourAudio.pause();
          this.setState({ mainPlaying: false, otherPlaying: false, forceMusicPause });
        }
      }
    } catch (e) {}
  };

  changeFloor = async (floorIndex: number, all = false) => {
    try {
      this.setState({ panoramaOn: false });
      await this.showCaseTemp.floor.changeFloor(floorIndex, this.state.tourPlaying, all);
    } catch (err) {
      console.error(err);
    }
  };

  playTour = async () => {
    try {
      this.setState({ panoramaOn: false });
      await this.showCaseTemp.tour.playTour(this.state.tourPlaying, this.state.reelStep);
    } catch (err) {
      console.error(err);
    }
  };

  changeViewMode = async (mode: TourMode) => {
    try {
      this.setState({ panoramaOn: false });
      await this.showCaseTemp.tour.changeViewMode(mode, this.state.tourPlaying);
    } catch (err) {
      console.error(err);
    }
  };

  measurementsMode = async () => {
    try {
      await this.showCaseTemp.tour.measurementsMode(this.state.tourPlaying);
    } catch (err) {
      console.error('Failed to change mode.');
    }
  };

  takePosition = (event: any) => {
    // ctrl+y
    if (event.ctrlKey && event.keyCode === 89) {
      const {
        tour: { slug, matterId },
      } = this.state;

      takePositionData({
        slug,
        matterId,
        sweep: this.pose.sweep,
        rotation: this.pose.rotation,
      });
    }
  };

  closeTagPop = async () => {
    const { showcaseLoaded, host, room } = this.state;
    if (showcaseLoaded && room && socket && socket.connected && host) {
      socket.emit('close-tag');
    }
    await this.resumeTourMusic();
    this.setState({ tagPopOn: false, openedTag: null, closedElementPopup: true });
  };

  closeConditionPopUp = () => {
    this.setState({
      conditionPopUp: null,
    });
  };

  closeGameLockPop = (isCorrect: boolean) => {};

  changeTagIconAndColor = async (tag, icon, color) => {
    const iconId = `${icon}__${Math.random()}`;
    const iconUrl = `${process.env.REACT_APP_DOMAIN || 'http://localhost:5030'}/v1/public/icons/${icon}?hex=${encodeURIComponent(color)}`;

    await this.showcase.Mattertag.registerIcon(iconId, iconUrl).catch((e) => {
      console.error(e);
    });
    await this.showcase.Mattertag.editIcon(tag.sid, iconId).catch((e) => {
      console.error(e);
    });
  };

  closePanoPop = () => {
    const { showcaseLoaded, host, room } = this.state;
    if (showcaseLoaded && room && socket && socket.connected && host) {
      socket.emit('close-pano-pop');
    }
    this.setState({ panoPopOn: false, openedPanoHotspot: null });
  };

  closeActionPop = () => {
    if (this.state.tourType === TourType.Game) {
      this.resumeTourMusic();
    }
    this.setState({ vsActionPopOn: false, closedElementPopup: true });
  };

  closePathFinderPop = () => {
    this.setState({ showPathFinderPopup: false });
  };

  showcaseLoad = () => {
    this.showcaseLoader(this.state.tour?.user?.mpSDK);
  };

  moveModel = async (url: string, keepRotation = false, instant = false) => {
    try {
      const THREE = ThreeInstance.get();
      const { id, iframeId, linkData, rand, linkDataShort } = getUrlVariables(url, this.state.iframeUrl);

      if (linkData) {
        const q = linkData.camera_quaternion;
        const quaternion = new THREE.Quaternion(q.x, q.y, q.z, q.w);
        let rotation = new THREE.Euler()
          .setFromQuaternion(quaternion, 'YXZ') // @ts-ignore
          .toVector3()
          .multiplyScalar(180 / Math.PI);
        if (keepRotation || linkData.showcase_sweep) {
          rotation = this.pose.rotation;
        }
        // eslint-disable-next-line eqeqeq
        if (id && iframeId && id?.toLowerCase() != iframeId?.toLowerCase()) {
          this.iframe.removeEventListener('load', this.showcaseLoad);
          this.iframe.addEventListener('load', this.showcaseLoad, { once: true });
          this.setState(
            {
              iframeUrl: `${url}&qs=${instant ? '1' : '0'}&play=1&refreshid=${rand}`,
              panoramaOn: false,
            },
            () => {
              if (this.state.room && this.state.host) {
                socket.emit('tour_load', { id, mp: true });
              }
            },
          );
        } else {
          await this.moveToSweep(linkData.scan_id, rotation, instant ? 'INSTANT' : 'FLY');
        }
      } else if (linkDataShort) {
        const xr = parseFloat(linkDataShort.sr[0] || '0');
        const yr = parseFloat(linkDataShort.sr[1] || '0');
        const zr = parseFloat(linkDataShort.sr[2] || '0');
        // eslint-disable-next-line no-nested-ternary
        const mode = linkDataShort.sm === 2 ? this.showCaseTemp.showcase.Mode.Mode.DOLLHOUSE : linkDataShort.sm === 3 ? this.showCaseTemp.showcase.Mode.Mode.FLOORPLAN : null;
        let position = null;
        if (linkDataShort.sp) {
          position = {
            x: parseFloat(linkDataShort.sp[0] || '0'),
            y: parseFloat(linkDataShort.sp[1] || '0'),
            z: parseFloat(linkDataShort.sp[2] || '0'),
          };
        }

        let rotation = new THREE.Euler()
          .set(xr, yr, zr, 'XYZ')
          .reorder('YXZ')
          .toVector3()
          .multiplyScalar(180 / Math.PI);

        rotation.z = 0;

        if (keepRotation) rotation = this.pose.rotation;

        // load another tour, not the same tour
        // eslint-disable-next-line eqeqeq
        if (id && iframeId && id.toLowerCase() != iframeId.toLowerCase()) {
          this.iframe.removeEventListener('load', this.showcaseLoad);
          this.iframe.addEventListener('load', this.showcaseLoad, { once: true });
          this.setState(
            {
              iframeUrl: `${url}&qs=${instant ? '1' : '0'}&play=1&refreshid=${rand}`,
              panoramaOn: false,
              activePano: null,
            },
            () => {
              if (this.state.room && this.state.host) {
                socket.emit('tour_load', { id, mp: true });
              }
            },
          );
        } else if (linkDataShort.ss) {
          const scanId = this.state.deprecatedSweeps[linkDataShort.ss - 1].sweep_uuid.replace(/-/g, '');
          await this.moveToSweep(scanId, rotation, instant ? 'INSTANT' : 'FLY');
        } else if (linkDataShort.sm && position) {
          // move to dollhouse
          await this.showCaseTemp.showcase.Mode.moveTo(mode, {
            position,
            rotation,
            transition: instant ? this.showCaseTemp.showcase.Mode.TransitionType.INSTANT : this.showCaseTemp.showcase.Mode.TransitionType.FLY,
            ...(linkDataShort.sz && { zoom: linkDataShort.sz }),
          });
        }
        // eslint-disable-next-line eqeqeq
      } else if (id && iframeId && id.toLowerCase() != iframeId.toLowerCase()) {
        this.iframe.removeEventListener('load', this.showcaseLoad);
        this.iframe.addEventListener('load', this.showcaseLoad, { once: true });
        // for no link data, just simple links
        this.setState(
          {
            iframeUrl: `${url}&qs=1&play=1&refreshid=${rand}`,
            panoramaOn: false,
            activePano: null,
          },
          () => {
            if (this.state.room && this.state.host) {
              socket.emit('tour_load', { id, mp: true });
            }
          },
        );
      }

      this.setState({
        overlayOn: false,
        markerPopupOn: false,
        panoramaOn: false,
      });
    } catch (err) {
      console.error(err);
    }
  };

  markerClick = (hotspot: any) => {
    this.setState({ minimapOn: false }, () => {
      if (hotspot.type === 'panorama') {
        const { minimaps, selectedMinimap } = this.state;
        minimaps[selectedMinimap].hotspots.map((h: any) => {
          hotspot.active = h.id === hotspot.id;
          return hotspot;
        });

        this.setState({
          panoramaOn: true,
          minimaps,
          activePano: hotspot.panoramaId,
          mapWalkerX: hotspot.x,
          mapWalkerY: hotspot.y,
        });
        return;
      }
      if (!hotspot.external) {
        this.setState({ overlayOn: false });
        if (hotspot.url) {
          const { whiteLabelData } = this.state;

          const type =
            hotspot.url.includes('my.treedis.com') || hotspot.url.includes(whiteLabelData?.domainUrl) || hotspot.url.includes('localhost:5000')
              ? MenuType.Treedis
              : MenuType.Matterport;

          this.loadModel(null, hotspot.url, type);
        } else {
          const start = encodeURIComponent(
            JSON.stringify({
              camera_mode: 1,
              scan_id: hotspot.scanId,
              showcase_sweep: hotspot.showcaseSweep,
              camera_position: {
                x: hotspot.positionX,
                y: hotspot.positionY,
                z: hotspot.positionZ,
              },
              camera_quaternion: {
                x: hotspot.rotationX,
                y: hotspot.rotationY,
                z: hotspot.rotationZ,
                w: hotspot.rotationW,
              },
            }),
          );
          this.moveModel(`/mp-sdk/${process.env.REACT_APP_SDK_VERSION}/showcase.html?applicationKey=${this.state.tour?.user?.mpSDK}&m=${this.state.tour.matterId}&start=${start}`);
        }
      } else {
        this.setState({
          selectedMarker: { url: hotspot.url, external: hotspot.external },
          markerPopupOn: true,
          overlayOn: true,
        });
      }
    });
  };

  releaseLock = () => {
    this.setState({ lock: false });
  };

  toggleAppointmentsModal = () => {
    this.setState({
      appointmentsModal: !this.state.appointmentsModal,
      appointmentsHintOn: false,
    });
    this.toggleExternalPopup();
  };

  handleCustomButton = () => {
    const { tour, externalPopupOn } = this.state;
    if (tour.customButtonOpenAs === CustomButtonTypeOpenAsType.Tab) {
      window.open(tour.customButtonUrl, '_blank');
      return;
    }
    if (externalPopupOn) return;
    this.setState({
      externalPopupUrl: tour.customButtonUrl,
      externalPopupOn: true,
    });
  };

  toggleNav = () => {
    const {
      menuOpen,
      tour: { menuAlwaysOpenMobile, menuAlwaysOpenDesktop },
      tourType,
    } = this.state;
    const menuOpenForDevice = tourType === TourType.Regular && !!(DeviceManager.isMobile() ? menuAlwaysOpenMobile : menuAlwaysOpenDesktop);
    this.setState({
      menuOpen: menuOpenForDevice || !menuOpen,
      menuOpened: true,
      activeMenu: null,
      MenuHintOn: false,
    });
  };

  disableContext = (e: any) => {
    e.preventDefault();
  };

  processTourMusic = async (tour: Tour) => {
    const { currentFloor } = this.state;
    let isTourMusic = false;
    let music = tour.musics.find((item) => item.floor === currentFloor + 1);
    if (!music && tour.music) {
      music = {
        autoplay: tour.autoplayMusic,
        url: `${process.env.REACT_APP_AWS}/tours/${tour.id}/music.mp3${all.getVersion(tour.updatedAt)}`,
      };
      isTourMusic = music.url === this.tourAudio?.src;
    }

    this.setState({ interacted: true });
    if (music) {
      if (this.tourAudio?.src && isTourMusic) return;
      await this.pauseAllAudio('tourAudio');
      this.createAudioStream('tourAudio', music.url, true);
      if (
        music.autoplay &&
        !(tour.noAudioMode && this.state.room) &&
        // in case of Intro Screen is enables, the music
        // should play after user clicks on play button
        !this.state.showIntroScreen
      ) {
        if (DeviceManager.supportsTouch()) {
          this.setState({ interacted: false });
          document.addEventListener(
            'touchstart',
            () => {
              this.setState({ interacted: true });
              this.playAudio();
            },
            { once: true },
          );
        } else if (DeviceManager.isSafari() && !DeviceManager.isChrome()) {
          this.setState({ interacted: false });
          document.addEventListener(
            'click',
            () => {
              this.setState({ interacted: true });
              this.playAudio();
            },
            { once: true },
          );
        } else {
          this.playAudio();
        }
      }
    } else {
      // added check for sweepAudio because it paused sweep audio when initial sweep had audio
      if (!this.sweepAudio) await this.pauseAllAudio();
      this.tagAudio = null;
      this.setState({ mainPlaying: false, otherPlaying: !!this.sweepAudio });
    }
  };

  pauseTourMusic = async () => {
    if (this.tourAudio && !this.tourAudio.ended && !this.tourAudio.paused) {
      await this.handleToggleMusic(false);
    }
  };

  resumeTourMusic = async () => {
    const { forceMusicPause, vsAudio } = this.state;

    console.log('RESUME MUSIC', forceMusicPause);
    if (this.tourAudio && this.tourAudio.paused && !this.tourAudio.ended && this.tourAudio.currentTime > 0 && !forceMusicPause && !vsAudio) {
      await this.handleToggleMusic();
    }
  };

  loadData = async (tourData: any, changeMenu = true, changeMinimap = true, changePanorama = true, url: any = null) => {
    const tour = new Tour(tourData);
    const stateTour = this.state.tour;
    const { tourType } = this.state;

    if (url) {
      const s = getQueryVariable(url, 's');
      const x = getQueryVariable(url, 'x');
      const y = getQueryVariable(url, 'y');

      if (s && x && y) {
        window.history.replaceState(null, '', this.buildLink(s, { x, y }));
      }
    }
    if (!changeMenu && stateTour) {
      tour.reel = stateTour.reel;
      tour.menuEnabled = stateTour.menuEnabled;
      tour.menuAlwaysOpenMobile = stateTour.menuAlwaysOpenMobile;
      tour.menuAlwaysOpenDesktop = stateTour.menuAlwaysOpenDesktop;
    }
    if (!changePanorama && stateTour) tour.panorama = stateTour.panorama;

    if (!changeMinimap && stateTour) {
      tour.originX = stateTour.originX;
      tour.originY = stateTour.originY;
      tour.height = stateTour.height;
      tour.width = stateTour.width;
      tour.ppm = stateTour.ppm;
      tour.customMinimap = stateTour.customMinimap;
      tour.minimap = true;
    }
    const m = getQueryVariable(window.location.href, 'm');
    let matterId = m ? atob(decodeURIComponent(String(m))) : tour.matterId;

    if (this.state.room) {
      if (this.state.host) {
        socket.emit('tour_load', { id: matterId, mp: false });
      } else if (matterId !== tour.matterId) {
        // if host uses a Tour Link, matterId should be updated with id of next tour
        matterId = tour.matterId;
      }
    }

    let addons = tour.getAddonsUrl();
    if (tour.introScreen) {
      addons = addons.replace(/qs=0/g, 'qs=1');
    }
    const menuOpenForDevice = tourType === TourType.Regular && !!(DeviceManager.isMobile() ? tour.menuAlwaysOpenMobile : tour.menuAlwaysOpenDesktop);
    const initialDuplicates = tourData?.initialDuplicates ? tourData.initialDuplicates : await PublicAPI.getDuplicates(tour.parentId || tour.id)?.duplicates;
    const menuOpen = changeMenu ? (this.state.room && !this.state.host ? false : tour.menuOnStart || menuOpenForDevice || false) : this.state.menuOpen;
    const china = all.getQueryVariable(window.location.href, 'china');
    this.setState(
      {
        initialDuplicates,
        menuOpen,
        changeMenu,
        tour,
        isVSEnabled: tour.enableVS,
        allowGuestBeforeHost: tour.allowGuestBeforeHost,
        showIntroScreen: !_isEmpty(tour.introScreen) && !tour.matterPassword,
        minimapVisible: tour.minimapVisible && !this.state.room && window.innerWidth > 768,
        iframeUrl: `/mp-sdk/${process.env.REACT_APP_SDK_VERSION}/showcase${china ? '-china' : ''}.html?applicationKey=${tour?.user?.mpSDK}&m=${matterId}${addons}&gl2=1`,
        appointmentsHintOn: tour.appointmentTooltipOn,
      },
      () => {
        if (this.iframe) {
          this.iframe.addEventListener('load', this.showcaseLoad, { once: true });
        }

        if (tour.disableContext) {
          document.addEventListener('contextmenu', this.disableContext);
        }

        fetchData(`public/getAgentsContactForm/${tour.id}`, 'GET')
          .then((data) => {
            const agents = data.agents.map((a: any) => new Agent(a.agent));
            this.setState({ agents });
          })
          .catch((err) => {
            console.error(err.message);
          });

        if (tour.minimap && changeMinimap) {
          fetchData('public/getMinimaps', 'POST', {
            id: tour.id,
          })
            .then((data) => {
              const { minimaps } = data;
              this.setState({ minimaps });
            })
            .catch((err) => {
              console.error(err.message);
            });
        }

        if (tour.panorama && changePanorama) {
          fetchData('public/getPanoramas', 'POST', {
            id: tour.id,
          })
            .then((data) => {
              const { panoramas } = data;
              const pano = getQueryVariable(window.location.href, 'pano');
              const pitch = parseInt(String(getQueryVariable(window.location.href, 'panoPitch'))) || 0;
              const yaw = parseInt(String(getQueryVariable(window.location.href, 'panoYaw'))) || 0;
              const hfov = parseInt(String(getQueryVariable(window.location.href, 'panoHfov'))) || 0;
              this.setState({
                panoramas,
                activePano: pano && parseInt(String(pano)),
                panoramaOn: tour.panoramaStart || Boolean(pano),
                panoPose: { pitch, yaw, hfov },
              });
            })
            .catch((err) => {
              console.error(err.message);
            });
        }

        PublicAPI.getGroups({ id: tour.id }).then((groupsData: any) => {
          this.setState({
            sweepGroups: groupsData?.groups || [],
          });
        });

        if (tour.gameId) {
          fetchData('public/getGame', 'POST', {
            id: tour.gameId,
          })
            .then((data) => {
              const game = new Game(data?.game);
              this.gameAnalytic = new GameAnalyticService(game.id);
              this.setState({
                showIntro: game.introClip && game.introClipUrl,
                gameLoaded: true,
                game,
                showBook: game?.book?.openByDefault,
              });
            })
            .catch((err) => {
              if (err?.response?.data?.message?.includes('trial')) this.setState({ gameTrialErr: err?.response?.data?.message });
              console.error(err.message);
            });
        }
      },
    );
  };

  getProducts = async (tourId: number, userId: number) => {
    return [];
  };

  showcaseLoader = async (applicationKey?: string) => {
    try {
      if (!this.iframe.contentWindow.MP_SDK) return;
      // to make the "copy position" work if focus is on the iframe
      await this.iframe.contentWindow.document.addEventListener('keydown', this.takePosition);
      const showcase = await GetSDK(this.iframe, {
        applicationKey: applicationKey || process.env.REACT_APP_MATTERPORT,
        appDomain: process.env.REACT_APP_DOMAIN || 'http://localhost:5030',
        version: process.env.REACT_APP_SDK_VERSION as string,
        logoUrl: null,
        appAws: process.env.REACT_APP_AWS,
      });

      this.showcase = showcase.showcase;
      this.showCaseTemp = showcase;
      this.loadedShowcaseHandler();
      this.showCaseTemp.on(TourLoaderEventsType.LOADING, async () => {
        this.loadingQueue.setLoadingQueueProgress(80, 100);
      });

      let starting = false;
      this.showCaseTemp.on(TourLoaderEventsType.STARTING, async () => {
        starting = true;
        const models = await this.showCaseTemp.showcase.Scene.query(['model']);
        this.camera = models[0].parent.children[0];
        await this.showCaseTemp.scene.configureThreeInstance();
        this.initStarting();
      });

      this.showCaseTemp.on(TourLoaderEventsType.PLAYING, async () => {
        if (!starting) {
          // Some tours don't have starting mode
          const models = await this.showCaseTemp.showcase.Scene.query(['model']);
          this.camera = models[0].parent.children[0];
          await this.showCaseTemp.scene.configureThreeInstance();
          await this.initStarting();
        }

        this.initPlaying();
        this.initScene();
        this.initSweep();
        const watchErrorElem = this.iframe.contentWindow.document.body.querySelector('#error-container');
        setErrorObserver(watchErrorElem, (pageCrashed, observer) => {
          this.setState({
            crashScreen: pageCrashed,
          });
          observer.disconnect();
        });
      });
      // eslint-disable-next-line prefer-destructuring
    } catch (e) {
      console.error(e);
    }
  };

  adjustVSToTourMode = () => {
    const { tourMode, tourType } = this.state;
    const outside = this.showCaseTemp.showcase.Mode.Mode.OUTSIDE;
    if (tourType === TourType.Game) return;
    if (tourMode !== this.pose.mode) {
      // mode changing
      if (this.pose.mode === outside) {
        // going outside, disable vs
        this.stopVS();
      } else if (tourMode === outside && this.pose.mode !== outside) {
        // going from outside to inside, init VS
        this.initVS();
      }
      this.setState({ tourMode: this.pose.mode });
    }
  };

  async loadedShowcaseHandler(cb = () => {}) {
    // Define showcase and event listeners
    const { tour, room } = this.state;

    if (tour?.enableAvatar || room) {
      socket.open();
    }

    const reel = await this.showCaseTemp.showcase.Tour.getData().catch(() => []);
    this.setState({ reel });
    this.showCaseTemp.showcase.Settings.update('highlight_reel', false);
    this.showCaseTemp.showcase.Settings.update('tour_buttons', false);

    if (tour.hidePucks) {
      this.showCaseTemp.showcase.Settings.update('features/sweep_pucks', false);
    }

    this.showCaseTemp.showcase.Camera.pose.subscribe((p: any) => {
      const { floors } = this.state;
      this.pose = { ...p };

      try {
        if (this.pose.sweep && floors.length) {
          for (let i = 0; i < floors.length; i += 1) {
            const floor = floors[i];
            const sweep = floor?.sweeps ? floor.sweeps.find((item) => item.uuid === this.pose.sweep) : null;
            if (sweep) {
              if (this.floor.floor !== sweep.floor_index) {
                this.floor = floor;

                if (this.showCaseTemp) {
                  // if floor is changed, rerender the VS
                  // this.initVS(); //TODO: check why?
                }
              }

              if (this.shadowNode) {
                const currentDeprecatedSweep = this.state?.deprecatedSweeps?.find((item) => item.sweep_uuid?.replace(/-/g, '') === this.pose.sweep);

                this.shadowNode.obj3D.position.set(
                  this.pose.position.x,
                  currentDeprecatedSweep?.floor_position.z + 0.01, // z is height
                  this.pose.position.z,
                );

                // turn of visibility for MP panorama sweeps
                this.shadowNode.obj3D.visible = this.pose.mode !== this.showCaseTemp.showcase.Mode.Mode.OUTSIDE;
              }
              break;
            }
          }
        }
        cb();
      } catch (e) {
        console.error(e);
      }
    });

    this.showCaseTemp.showcase.Sweep.current.subscribe((currentSweep) => {
      this.adjustVSToTourMode();
      if (currentSweep.sid !== '') {
        this.updateSweepLoc(currentSweep.sid);
        this.setState({ currentSweep });
      }
    });

    this.showCaseTemp.showcase.on(this.showCaseTemp.showcase.Camera.Event.MOVE, async (p: any) => {
      const { showcaseLoaded, host, room, tour, panoramaOn } = this.state;
      if (!showcaseLoaded) return;
      if (socket && socket.connected) {
        // position of avatar on the circle
        const pose = {
          walking: p.mode === this.showCaseTemp.showcase.Mode.Mode.INSIDE,
          position: p.position,
          rotation: this.camera?.camera.rotation,
          quaternion: this.camera?.camera.quaternion,
          mode: p.mode,
          degree: this.avatarDegree,
        };
        if (room) {
          if (host) {
            socket.emit('move', { pose: { ...p, walking: p.mode === this.showCaseTemp.showcase.Mode.Mode.INSIDE } });
          }
        }

        if (tour?.enableAvatar) {
          socket.emit('move_avatar', { pose });
        }
      }

      if (tour.minimap) {
        if (p.mode === this.showCaseTemp.showcase.Mode.Mode.INSIDE && !panoramaOn) {
          this.setState({ mapWalkerRotation: p.rotation.y * -1 });
        }
      }
    });

    this.showCaseTemp.showcase.Floor.current.subscribe((floor: any) => {
      if (floor.sequence !== -1 && floor.sequence !== undefined && floor.sequence !== this.state.selectedMinimap) {
        const { minimaps } = this.state;
        if (minimaps.length > 0 && minimaps[floor.sequence]) {
          this.setState({ selectedMinimap: floor.sequence });
        }
      }
      if (floor.sequence !== -1 && floor.sequence !== undefined && this.state.currentFloor !== floor.sequence) {
        this.setState(
          {
            currentFloor: floor.sequence,
          },
          () => {
            this.processTourMusic(tour);
          },
        );
      }
    });

    this.showCaseTemp.showcase.Measurements.mode.subscribe((measurementModeState: any) => {
      this.setState({ mesurementsOn: measurementModeState.active });
    });

    this.showCaseTemp.showcase.on(this.showCaseTemp.showcase.Tour.Event.STEPPED, (i: number) => {
      this.setState({ reelStep: i, panoramaOn: false });
    });

    this.showCaseTemp.showcase.on(this.showCaseTemp.showcase.Tour.Event.STARTED, () => {
      this.setState({ tourPlaying: true, panoramaOn: false, tourMode: this.pose.mode });
    });

    this.showCaseTemp.showcase.on(this.showCaseTemp.showcase.Tour.Event.STOPPED, () => {
      this.setState({ tourPlaying: false, panoramaOn: false });
    });

    this.showCaseTemp.showcase.on(this.showCaseTemp.showcase.Tour.Event.ENDED, () => {
      this.setState({ tourPlaying: false, panoramaOn: false, reelStep: 0 });
    });

    this.showcase.on(this.showcase.Mattertag.Event.CLICK, (tagId: string) => {
      const { room, host, showcaseLoaded } = this.state;
      const tags = Array.from(this.state.allTags.values());
      const tag: any = tags.find((t: any) => t.sid === tagId || t.defaultSid === tagId);
      if (room && socket && socket.connected && host && showcaseLoaded) {
        socket.emit('tag', {
          tag: { id: tag.sid, action: 'click' },
        });
      }

      this.openTagIframe(tagId);
      if (tag && tag.title) {
        sendToGA('event', {
          eventCategory: 'Mattertag',
          eventAction: 'click',
          eventLabel: tag.title,
        });
      }
    });

    this.showcase.on(this.showcase.Mattertag.Event.HOVER, (tagId: string) => {
      const { room, host, showcaseLoaded } = this.state;
      const tags = Array.from(this.state.allTags.values());
      const tag: any = tags.find((t: any) => t.sid === tagId || t.defaultSid === tagId);
      if (showcaseLoaded && room && socket && socket.connected && host && this.pose.mode === this.showcase.Mode.Mode.INSIDE) {
        if (tag) {
          socket.emit('tag', {
            tag: { id: tag.sid },
          });
        }
      }
      if (tag && tag.enabled && tag.embedMedia && tag.type === 'video') {
        this.pauseTourMusic();
      }

      if (tag && tag.title) {
        sendToGA('event', {
          eventCategory: 'Mattertag',
          eventAction: 'hover',
          eventLabel: tag.title,
        });
      }
    });

    this.showCaseTemp.showcase.Floor.data.subscribe({
      // Get floor data
      onCollectionUpdated: (collection: any) => {
        const mpFloors = [];
        Object.keys(collection).forEach((o) => {
          const floor = collection[o];
          if (!floor.name || floor.name.length === 0) return;
          mpFloors.push(floor);
        });
        this.setState({ mpFloors });
      },
    });

    this.showCaseTemp.showcase.Label.getData()
      .then((labels) => {
        this.setState({ mpLabels: labels });
      })
      .catch(() => console.error('Error to load MP labels'));

    this.showCaseTemp.showcase.Mattertag.data.subscribe({
      onAdded: (sid, item) => {
        const { room } = this.state;
        if (room && item.media.type === this.showCaseTemp.showcase.Mattertag.MediaType.VIDEO) {
          // ToDo: matterport vimeo video does not support mute
          const clone = _cloneDeep(item);
          const urlC = clone.media.src.split('https://vimeo.com/');
          clone.media.src += urlC.length > 1 ? '?muted=1' : '&muted=1';
          this.showCaseTemp.showcase.Mattertag.editBillboard(sid, clone);
        }
      },
    });
  }

  initPlaying = async () => {
    const { tour, loadedOnce, iframeUrl } = this.state;
    this.setState({ appState: 'playing' });

    // in case the tour goes directly into playing
    const matterId = getQueryVariable(iframeUrl, 'm');

    // Support for matterport->treedis->matterport
    const url = window.location.href;
    const s = getQueryVariable(url, 's');
    const x = getQueryVariable(url, 'x');
    const y = getQueryVariable(url, 'y');

    if (s && x && y) {
      // We move inside the tour
      this.moveToSweep(String(s), { x: parseFloat(x), y: parseFloat(y) });
    }

    if (!loadedOnce) {
      startGA(tour, true);
    }

    // TODO:: Remove when Matterport will fix problem with current floor
    if (matterId === 'VE4rJCNFfba') {
      this.floor.floor = 2;
    }

    this.setState({ loadedOnce: true }, async () => {
      if (tour.addon_ts >= 0 && tour.mpPlay) {
        setTimeout(() => {
          this.playTour();
        }, tour.addon_ts * 1000);
      }

      try {
        const hash = window.location.hash.substring(1);
        if (hash) {
          this.loadModel(null, null, MenuType.Product, hash, null);
        }
        this.processTourMusic(tour);
        const { polygons } = this.state;
        await this.showCaseTemp.scene.configureScene({
          settings: this.state.vsSettings,
          onShadowEnabled: (value) => {
            this.isShadowEnabled = value;
          },
          onShadowNodeCreated: (shadowNode) => {
            this.shadowNode = shadowNode;
          },
          cb: () => {
            this.setState({ isVSReady: true });
          },
        });
        await this.showCaseTemp.showcase.Scene.register(avatarComponentType, makeAvatarComponent);
        if (polygons?.length || this.vsObjects?.length) {
          if (polygons?.length) {
            await this.initPolygons();
          }
          if (this.vsObjects?.length) {
            await this.initVS();
          }
        }
        await this.initAvatar();
      } catch (err) {
        console.error(err);
      }
    });
  };

  initStarting = async () => {
    try {
      this.setState({ appState: 'starting' });

      const { tour, tourType, showcaseLoaded, isChangeIframe, iframeUrl, showIntroScreen } = this.state;
      const condition = tourType === TourType.Game ? true : !showcaseLoaded || isChangeIframe;
      const matterId = getQueryVariable(iframeUrl, 'm');
      if (!condition) return;

      this.loadingQueue.setLoadingQueueProgress(70, 100);
      const tagsRes = await PublicAPI.getTags({
        matterId,
        slug: matterId === tour.matterId ? tour.slug : null,
      });
      const mpTags = tagsRes.matterTags;
      const treedisTags = tagsRes.tags;
      this.loadingQueue.setLoadingQueueProgress(60, 100);

      // isMatterportLink - when tour is loaded via link of Matterport type
      const isMatterportLink = getQueryVariable(this.state.iframeUrl, 'm') !== tour.matterId;
      /* Concurrent (Non-blocking requests) */
      const { polygons, vsObjects, vsSettings, products } = await getVSItems(isMatterportLink, {
        slug: tour.slug,
        userId: tour.userId,
        id: tour.id,
        tourType,
      });
      this.loadingQueue.setLoadingQueueProgress(50, 100);

      this.vsObjects = vsObjects.filter((obj) => obj.active); // TODO: move to backend..
      // if no VS objects, Media Images of Media Videos found - loadingQueueProgress is set to 100%
      // to do not display the loading indicator for VS
      if (!this.vsObjects.length || !showIntroScreen) {
        //if there is no intro screen, we don't wait for VS!
        this.loadingQueue.setFullLoadingQueueProgress();
      } else if (this.pose) {
        const THREE = ThreeInstance.get();
        const pose = new THREE.Vector3(this.pose?.position.x, this.pose.position.y, this.pose.position.z);
        const isVisibleAsset = this.vsObjects.find((asset) => {
          const assetPose = new THREE.Vector3(asset.positionX, asset.positionY, asset.positionZ);
          const distance = pose.distanceTo(assetPose);
          return distance <= DEFAULT_VS_SENSOR_RADIUS;
        });

        if (!isVisibleAsset) {
          this.loadingQueue.setFullLoadingQueueProgress();
        }
      }

      this.setState({ allTags: new Map(), polygons, products, vsSettings, isProductsLoaded: true }, () => {
        Mattertag.subscribe({ mpSdk: this.showCaseTemp.showcase, mpTags, treedisTags }, (allTags) => {
          this.setState({ allTags }, async () => {
            const { allTags } = this.state;
            const tags = await this.initTags(Array.from(allTags.values()));
            this.setState({ loadingTags: false, allTags: tags }, async () => {
              try {
                this.hiddenTags = {};
                this.visibleTags = {};
                this.filterTags();
              } catch (err) {
                console.error(err);
              }
            });
          });
        });
        this.setState({ showcaseLoaded: true, isChangeIframe: false });
      });
    } catch (err) {
      console.error(err);
    }
  };

  initSweep = async () => {
    this.showCaseTemp.sweep.subscribe((sweeps) => {
      this.setState(
        {
          sweeps,
          sweepsLoaded: true,
        },
        () =>
          afterSweepsInit({
            sweeps: this.state.sweeps,
            matterId: this.state.tour.matterId,
            slug: this.state.tour.slug,
            iframeUrl: this.state.iframeUrl,
            setData: (data) => {
              this.setState(data);
            },
            cb: () => {
              const s = getQueryVariable(window.location.href, 's');
              const x = getQueryVariable(window.location.href, 'x');
              const y = getQueryVariable(window.location.href, 'y');
              if (this.pose.mode === this.showCaseTemp.showcase.Mode.Mode.INSIDE && s && x && y) {
                if (this.state.sweeps.some((sweep) => s === sweep.uuid)) {
                  this.moveToSweep(String(s), { x: parseFloat(x), y: parseFloat(y) });
                }
              }
            },
          }),
      );
    });
  };

  initScene = async () => {
    this.showCaseTemp.tag.on(TagEventsType.OpenTagIframe, ({ event, tagId }) => {
      if (event === this.showCaseTemp.tags.matterTag.Event.CLICK) {
        this.setState({
          clickedElement: {
            id: tagId,
            type: EntityType.Tag,
          },
        });
      }
    });

    this.showCaseTemp.scene.sceneObject.on(NodeEventsTypes.OBJECT_CLICK, ({ data }) => {
      if (this.state.tourType === TourType.Game) {
        this.openVsObjectIframe(data);
      }
      this.setState({
        clickedElement: {
          id: data.details.id,
          type: EntityType.VSItem,
        },
      });
    });

    this.showCaseTemp.scene.sceneImage.on(NodeEventsTypes.IMAGE_HOVER, ({ eventData, data }: any) => {
      if (data.actionType === TourImageActionType.None) {
        return;
      }

      this.iframe.contentWindow.document.body.style.cursor = eventData.hover ? 'pointer' : 'auto';

      if (data.action === TourImageAction.Hover && eventData.hover) {
        this.handleImageAction(data);
      }
    });

    this.showCaseTemp.scene.sceneImage.on(NodeEventsTypes.IMAGE_CLICK, ({ eventData, data }: any) => {
      if (this.state.tourType === TourType.Game) {
        this.openVsImageIframe(data);
      }
      if (data.actionType === TourImageActionType.None) {
        return;
      }
      if (data.action === TourImageAction.Click) {
        this.handleImageAction(data);
      }

      this.setState({
        clickedElement: {
          id: data.details.id,
          type: EntityType.VSImage,
        },
      });
    });

    this.showCaseTemp.scene.sceneImage.on(NodeEventsTypes.AVATAR_BUTTON_HOVER, ({ eventData }: any) => {
      this.iframe.contentWindow.document.body.style.cursor = eventData.hover ? 'pointer' : 'auto';
    });
    this.showCaseTemp.scene.scenePolygon.on(NodeEventsTypes.POLYGON_EVENTS, ({ type, component, eventData, data }: any) => {
      const handleAction = (action: PolygonAction, eventType: string, eventData) => {
        if (!action) {
          return;
        }
        if (action.type === PolygonActionType.None) {
          return;
        }
        if (action.action === PolygonActionAction.Hover && eventType === VSInteractionType.HOVER && eventData.hover) {
          this.handlePolygonAction(action);
        }
        if (action.action === PolygonActionAction.Click && eventType === VSInteractionType.CLICK) {
          this.handlePolygonAction(action);
        }
      };

      const isGameTour = this.state.tourType === TourType.Game && this.state.tour.gameId;
      const isECommerceTour = this.state.tourType === TourType.ECommerce;

      if (type === VSInteractionType.HOVER) {
        this.iframe.contentWindow.document.body.style.cursor = eventData.hover ? 'pointer' : 'auto';
      }

      if (type === VSInteractionType.CLICK) {
        this.setState({
          clickedElement: {
            id: data?.details?.id || data?.id,
            type: EntityType.Polygon,
          },
        });
      }

      if (isGameTour) {
        if (type === VSInteractionType.CLICK) {
          // @ts-ignore
          const result = this.handlePolygonLock && this.handlePolygonLock(data.id);
          this.unlockChapter && this.unlockChapter(data, ChapterType.Polygon);
          if (result) {
            const action = data.polygonsActions.find((i) => i.mode === PolygonActionMode.VS);
            const polygonAction = new PolygonAction(action);
            handleAction(polygonAction, type, eventData);
            if (polygonAction.gameBackpack && !this.state.polygonsBackpack.find(({ id }) => data.id === id)) {
              this.setState({
                polygonsBackpack: [data, ...this.state.polygonsBackpack],
              });
            }
          } else if (result === undefined) {
            component.setSelection();
          }
        }
      } else if (isECommerceTour && data.products.length && type === VSInteractionType.CLICK) {
        this.handlePolygonProduct && this.handlePolygonProduct(data);
      } else {
        const action = data.polygonsActions.find((i) => i.mode === PolygonActionMode.VS);
        handleAction(new PolygonAction(action), type, eventData);
      }
    });

    this.showCaseTemp.scene.sceneVideo.on(NodeEventsTypes.VIDEO_HOVER, ({ data }: any) => {});

    this.showCaseTemp.scene.sceneVideo.on(NodeEventsTypes.VIDEO_CLICK, ({ data }: any) => {
      if (this.state.tourType === TourType.Game) {
        this.openVsVideoIframe(data);
      }
      this.setState({
        clickedElement: {
          id: data.details.id,
          type: EntityType.VSVideo,
        },
      });
    });

    this.showCaseTemp.scene.sceneVideo.on(NodeEventsTypes.VIDEO_BUTTON_HOVER, ({ eventData, data }: any) => {
      this.iframe.contentWindow.document.body.style.cursor = eventData.hover ? 'pointer' : 'auto';
    });

    this.showCaseTemp.scene.sceneVideo.on(NodeEventsTypes.VIDEO_BUTTON_CLICK, ({ eventData, data, component, muteBtnComponent }: any) => {
      if (component.isMuted()) {
        const audio = this.getOtherAudio();
        if (audio) {
          this.setState({ restoreAudio: audio });
        }

        this.setState(
          {
            vsAudio: { component, btn: muteBtnComponent },
          },
          () => this.pauseAllAudio('', false),
        );
      } else if (this.state.restoreAudio) {
        this.state.restoreAudio.play();
        this.setState({
          restoreAudio: null,
          otherPlaying: true,
        });
      } else {
        this.setState(
          {
            vsAudio: null,
          },
          () => this.resumeTourMusic(),
        );
      }

      if (muteBtnComponent.isActive()) {
        const vsVideos = this.vsObjects?.filter((obj) => obj.node?.components && obj.node?.components[0]?.instance?.componentType === videoRendererType);
        vsVideos?.forEach((obj) => {
          const [vsVideo, muteBtn] = obj.node?.components;
          if (!muteBtn.instance.active) {
            vsVideo.instance.video.muted = true;
            muteBtn.instance.active = true;
            muteBtn.instance.makeBtn(muteBtn.instance.inputs.src);
          }
        });
      }
      component.toggleMute();
      muteBtnComponent.setActive(!muteBtnComponent.isActive());
    });
  };

  initObjectNode = async (asset: VSTourAsset) => {
    /** helper method for different render functions */

    let node;

    // render the VS object
    if (asset instanceof TourImage) {
      node = await this.initImageNode(asset);
    } else if (asset instanceof TourVideo) {
      node = await this.initVideoNode(asset);
    } else {
      node = await this.initNode(asset);
    }

    if (node?.[0]) {
      return node[0];
    }

    return null;
  };

  setVSVisible = async (vsObject: any, visible: boolean) => {
    if (visible && !vsObject.started) {
      vsObject.started = true; // we do it here because initObjectNode can take time
      vsObject.node = await this.initObjectNode(vsObject);
    } else if (!visible && vsObject.started && vsObject.node) {
      vsObject.started = false;
      vsObject.node.stop();
    }
  };

  initVS = async () => {
    /** method for sensors processing, LOD and other calculations */
    const { isVSReady } = this.state;
    const isGameTour = this.state.tourType === TourType.Game && this.state.tour.gameId;

    if (!isVSReady) return; // VS should be initialized for using!

    const isMPPano = await this.isMPPano();
    if (isMPPano) return;

    this.sensor?.dispose();

    // if its a game we load everything regardless of radius or sensor.
    if (isGameTour) {
      this.vsObjects.forEach((obj: any) => {
        this.loadingQueue.enqueue(async () => {
          await this.setVSVisible(obj, true);
          this.loadingQueue.dequeue();
        });
      });
      return; // no need for sensor if its a game..
    }

    // https://matterport.github.io/showcase-sdk/docs/sdkbundle/reference/current/modules/sensor.html
    this.sensor = await this.showCaseTemp.showcase.Sensor.createSensor(this.showCaseTemp.showcase.Sensor.SensorType.CAMERA);
    // this.sensor.showDebug(true);

    const handleSensorChange = async (source: any, reading: any) => {
      const index = this.vsObjects.findIndex((item) => item.id === source.userData.id);
      if (index < 0) return;
      const vsObject = this.vsObjects[index];

      if (reading.inRange) {
        this.loadingQueue.enqueue(async () => {
          await this.setVSVisible(vsObject, true);
          this.loadingQueue.dequeue();
        });
      } else if (vsObject.node) {
        await this.setVSVisible(vsObject, false);
      }
    };

    // start listening for changes to the sensor's readings, when not in game!
    this.sensor.readings.subscribe({
      onAdded: handleSensorChange,
      onUpdated: handleSensorChange,
    });

    const sources = await Promise.all(
      this.vsObjects.map((asset) => {
        // @ts-ignore
        const vsIdentifiers = { isVSImage: Boolean(asset.isVSImage), isVSVideo: Boolean(asset.isVSVideo) };
        return this.showCaseTemp.showcase.Sensor.createSource(this.showCaseTemp.showcase.Sensor.SourceType.SPHERE, {
          origin: {
            x: asset.positionX,
            y: asset.positionY + 0.1,
            z: asset.positionZ,
          },
          radius: DEFAULT_VS_SENSOR_RADIUS,
          userData: {
            id: asset.id,
            uuid: asset.uuid,
            ...vsIdentifiers,
          },
        });
      }),
    );

    this.sensor.addSource(...sources);
  };

  stopVS = async () => {
    try {
      this.vsObjects.map((asset: any) => {
        this.setVSVisible(asset, false);
      });
      this.sensor?.dispose();
    } catch (e) {
      console.error(e);
    }
  };

  initPolygons = async () => {
    const promises = this.state.polygons.map(async (item: Polygon) => {
      if (!item.active) {
        return item;
      }
      if (!item.uuid) {
        const node = await this.initPolygonNode(item);
        this.modelNodes.push(node);
        item.uuid = node[0].obj3D.uuid;
        return item;
      }
      return item;
    });
    this.setState({
      polygons: await Promise.all(promises),
    });
  };

  getPolygons() {
    return this.state.polygons;
  }

  initNode = async (data: TourObject) => {
    const res = await this.showCaseTemp.scene.sceneObject.create(data);
    if (!res.length) {
      return [];
    }

    return res;
  };

  initImageNode = async (data: TourImage) => {
    const res = await this.showCaseTemp.scene.sceneImage.create(data);
    if (!res.length) {
      return [];
    }

    return res;
  };

  /*

  */

  initVideoNode = async (data: TourVideo) => {
    const options = { vimeoURL: '', withButton: { mute: '/images/mute_icon.png', unMute: '/images/unmute_icon.png' } };
    const elementType = data.details.type;
    if (elementType === VSVideoType.Vimeo && this.state.tour.clientId) {
      const VimeoVideo = await import('@/components/tour/regular/vimeoVideo').then((res) => res.default);
      const vimeoVideo = new VimeoVideo(VimeoVideo.parseVideoId(data.getVideoURL()) as unknown as string);
      await vimeoVideo.loadFromVideoId(this.state.tour.clientId);
      options.vimeoURL = await PublicAPI.getVimeoVideoUrl(vimeoVideo.getFileURL());
    }

    const res = await this.showCaseTemp.scene.sceneVideo.create(data, options);
    if (!res.length || res.length === 1) {
      return [];
    }

    return res;
  };

  isMPPano = async () => this.pose.mode === this.showCaseTemp.showcase.Mode.Mode.OUTSIDE;

  initPolygonNode = async (data: Polygon) => {
    return await this.showCaseTemp.scene.scenePolygon.create(data);
  };

  initAvatarNode = async (data: Avatar) => {
    return await this.showCaseTemp.scene.sceneAvatar.create(data, {
      host: this.state.host,
      withButton: { mute: '/images/mute_icon.png', unMute: '/images/unmute_icon.png' },
    });
  };

  handlePolygonProduct(polygon: any) {}

  handleImageAction = async (data: TourImage) => {
    const { noAudioMode, id: tourId } = this.state.tour;

    switch (data.actionType) {
      case TourImageActionType.Tab:
        if (data.action === TourImageAction.Hover) {
          window.open(data.actionURL);
        } else if (data.action === TourImageAction.Click) {
          window.open(data.actionURL);
        }
        return;
      case TourImageActionType.Music:
        if (noAudioMode && this.state.room) return;

        const src = `${process.env.REACT_APP_AWS}/tours/${this.state.tour.id}/vsimages/${data.actionURL}`;
        if (this.polygonAudio) {
          if (this.polygonAudio.src === src && data.action === TourImageAction.Hover) {
            return;
          }
        }

        await this.pauseAllAudio('polygonAudio');
        this.polygonAudio = await this.createAudioStream('polygonAudio', src, true);
        await this.playContainerAudio('polygonAudio');
        this.setState({ mainPlaying: false, otherPlaying: true });
        return;
      case TourImageActionType.Video:
        data.actionURL = getVideoLink(data.actionURL, {
          mute: noAudioMode && this.state.room,
        });
        if (this.state.tourType === TourType.Game) {
          this.pauseTourMusic();
        } else {
          await this.pauseAllAudio();
          this.setState({ mainPlaying: false, otherPlaying: false });
        }
        break;
      case TourImageActionType.Treedis:
        const segments = data.actionURL.split('/');
        const id = segments[segments.length - 1].split('?')[0];
        if (getQueryVariable(data.actionURL, 'm')) {
          toast.error("Cannot use this link. To copy location in the tour, please use 'CTRL+Y'");
          return;
        }
        const { tour } = this.state;
        const changeMinimap = tour && !tour.customMinimap;
        this.setState({ panoramaOn: false, activePano: null }, () => {
          // false = dont change the menu/panorama
          this.getTour({ id, changeMenu: false, changeMinimap, changePanorama: false, url: data.actionURL });
        });
        return;
      case TourImageActionType.Menu:
        this.setState(
          {
            menuOpen: false,
            activeMenu: null,
          },
          () => {
            this.setState({
              menuOpen: true,
              menuOpened: true,
              activeMenu: {
                id: data.menuId,
                subMenu: data.subMenuId,
                subSubMenu: data.subSubMenuId,
              },
            });
          },
        );
        return;
      case TourImageActionType.Panorama:
        this.setState({
          activePano: data.panoramaId,
          panoramaOn: true,
        });
        return;
      case TourImageActionType.ExperiencePopUp: {
        const tourMusicWasPaused = this.tourAudio && !this.tourAudio.ended && !this.tourAudio.paused;
        if (this.state.tourType === TourType.Game) {
          await this.pauseTourMusic();
        } else {
          await this.pauseAllAudio();
          this.setState({ mainPlaying: false, otherPlaying: false });
        }
        this.setState({
          tourMusicWasPaused,
          experiencePopUpIsOpen: true,
          closedElementPopup: false,
          experiencePopUpData: {
            title: data.popupTitle,
            url: data.actionURL,
            description: data.text,
            defaultImageUrl: data?.details?.url,
            prefixImageUrl: `/tours/${tourId}/vsimages/`,
            rotation: data.rotation,
            backgroundColor: data.backgroundColor,
            backgroundOpacity: data.backgroundOpacity,
            textColor: data.textColor,
            buttonColor: data.buttonColor,
          },
        });
        return;
      }
      default:
    }

    this.setState({
      vsActionPopOn: true,
      openedVSAction: data,
      closedElementPopup: false,
    });
  };

  handlePolygonAction = async (data: PolygonAction) => {
    const { noAudioMode } = this.state.tour;

    switch (data.type) {
      case PolygonActionType.Tab:
        if (data.action !== PolygonActionAction.Hover) {
          window.open(data.url);
        }
        return;
      case PolygonActionType.Music:
        if (noAudioMode && this.state.room) return;

        const src = `${process.env.REACT_APP_AWS}/tours/${this.state.tour.id}/polygons/${data.url}`;
        if (this.polygonAudio) {
          if (this.polygonAudio.src === src && data.action === PolygonActionAction.Hover) {
            return;
          }
        }
        await this.pauseAllAudio('polygonAudio');

        this.polygonAudio = await this.createAudioStream('polygonAudio', src, true);
        await this.playContainerAudio('polygonAudio');
        this.setState({ mainPlaying: false, otherPlaying: true });
        return;
      case PolygonActionType.Video:
        data.url = getVideoLink(data.url, {
          mute: noAudioMode && this.state.room,
          autoplay: data.autoPlay ? 1 : 0,
        });
        await this.pauseAllAudio();
        this.setState({ mainPlaying: false, otherPlaying: false });
        break;
      case PolygonActionType.Treedis:
        const segments = data.url.split('/');
        const id = segments[segments.length - 1].split('?')[0];
        if (getQueryVariable(data.url, 'm')) {
          toast.error("Cannot use this link. To copy location in the tour, please use 'CTRL+Y'");
          return;
        }
        const { tour } = this.state;
        const changeMinimap = tour && !tour.customMinimap;
        this.setState({ panoramaOn: false, activePano: null }, () => {
          // false = dont change the menu/panorama
          this.getTour({ id, changeMenu: false, changeMinimap, changePanorama: false, url: data.url });
        });
        return;
      case PolygonActionType.Menu:
        this.setState(
          {
            menuOpen: false,
            activeMenu: {
              id: null,
              subMenu: null,
              subSubMenu: null,
            },
          },
          () => {
            this.setState({
              menuOpen: true,
              menuOpened: true,
              activeMenu: {
                id: data.menuId,
                subMenu: data.subMenuId,
                subSubMenu: data.subSubMenuId,
              },
            });
          },
        );
        return;
      case PolygonActionType.Panorama:
        this.setState({
          activePano: data.panoramaId,
          panoramaOn: true,
        });
        return;
      default:
    }

    this.setState({
      vsActionPopOn: true,
      closedElementPopup: false,
      openedVSAction: new PolygonAction(data),
    });
  };

  updateSweepLoc = (nextSweep: string) => {
    this.ticketUpdateSweepLoc(nextSweep);
    if (this.pose.mode !== this.showCaseTemp.showcase.Mode.Mode.INSIDE) return;
    const { tour, sweepGroups } = this.state;
    sendToGA('event', {
      eventCategory: 'Sweep',
      eventAction: 'move',
      eventLabel: nextSweep,
    });

    let activeSweepGroup = null;
    sweepGroups.forEach((group: any, i: number) => {
      group.sweeps?.forEach((sweep: any) => {
        if (sweep.uuid === nextSweep) {
          activeSweepGroup = group.id;
        }
      });
    });

    this.setState(
      {
        activeSweepGroup,
      },
      () => {
        this.resumeMusicAfterSweepGroup();
        this.filterTags();
      },
    );
    if (tour.minimap) {
      const loc: any = this.calculateLocation();
      if (!loc) return;
      this.setState({
        mapWalkerX: loc.px,
        mapWalkerY: loc.py,
        minimaps: loc.minimaps,
      });
    }
  };

  resumeMusicAfterSweepGroup = () => {
    const { currentFloor, tour, activeSweepGroup, forceMusicPause, tagPopOn, openedTag } = this.state;
    if (activeSweepGroup !== null) return;

    const music = tour.musics.find((item) => item.floor === currentFloor + 1);
    let autoplay = music?.autoplay || false;
    if (!music && tour.music) {
      autoplay = tour.autoplayMusic;
    }

    if (autoplay && !tour.noAudioMode && !forceMusicPause) {
      const vsVideos = this.vsObjects?.filter((obj) => obj.node?.components && obj.node?.components[0]?.instance?.componentType === videoRendererType);
      const hasActiveVsVideo = vsVideos?.find((vsVideo) => {
        const [videoBtn] = vsVideo.node?.components;
        return !videoBtn?.instance?.active;
      });

      if (!hasActiveVsVideo && !(tagPopOn && openedTag.type === 'video')) {
        this.playAudio();
      }
    }
  };

  markMinimap = (p: any) => {
    const { minimaps, selectedMinimap } = this.state;
    if (!minimaps || minimaps.length === 0 || selectedMinimap === null) return;
    minimaps[selectedMinimap].hotspots.forEach((h: any) => {
      if (h.type === 'panorama' && h.panoramaId === p.id) {
        this.setState({
          mapWalkerX: h.x,
          mapWalkerY: h.y,
          activePano: null,
        });
      }
    });
  };

  async moveToSweepIO(p: any) {
    if (this.state.showcaseLoaded) {
      setTimeout(() => {
        if (!p.walking) {
          this.showCaseTemp.showcase.Mode.moveTo(p.mode, {
            position: p.position,
            rotation: p.rotation,
            transition: this.showCaseTemp.showcase.Mode.TransitionType.FLY,
          }).catch((e: any) => {});
        } else {
          this.showcase.Sweep.moveTo(p.sweep, {
            position: p.position,
            rotation: p.rotation,
            transition: this.showCaseTemp.showcase.Sweep.Transition.FLY,
          }).catch((e: any) => {});
        }
      }, 100);
    }
  }

  moveToTagIO(tag: any, doOpenTag = true) {
    if (this.state.showcaseLoaded) {
      setTimeout(() => {
        const tags = Array.from(this.state.allTags.values());
        const foundTag: any = tags.find((t: any) => t.sid === tag.sid || t.defaultSid === tag.sid);
        if (!foundTag) {
          return;
        }

        if (this.pose.mode !== this.showCaseTemp.showcase.Mode.Mode.OUTSIDE) {
          this.showCaseTemp.showcase.Mattertag.navigateToTag(foundTag.sid, this.showCaseTemp.showcase.Mattertag.Transition.FLY)
            .then(() => {
              if (doOpenTag) {
                this.openTagIframe(tag.id);
              }
            })
            .catch((err: any) => {
              console.error(err.toString());
            });
        } else if (doOpenTag) {
          this.openTagIframe(foundTag.sid);
        }
      }, 100);
    }
  }

  playAudio = async () => {
    try {
      const { activeSweepGroup, sweepGroups, showIntro, tourType, videoPlaying } = this.state;
      const group = activeSweepGroup ? sweepGroups.find((sg: any) => sg.id === activeSweepGroup) : null;
      if (tourType === TourType.Game && showIntro) return;
      if (videoPlaying || (group?.type === SweepType.Music && group.overrideMusic)) {
        return;
      }
      if (this.tourAudio?.paused) {
        await this.pauseAllAudio('tourAudio');
        await this.tourAudio.play();
        this.setState({ mainPlaying: true, otherPlaying: false });
      }
    } catch (e) {
      console.error(`Error start playAudio ${e.message}`);
      setTimeout(this.playAudio, 500);
    }
  };

  moveToSweep = async (sweepId: string, rotation: any, transition = 'INSTANT') => {
    if (this.showCaseTemp) {
      return this.showCaseTemp.showcase.Sweep.moveTo(sweepId, {
        rotation,
        transition: this.showCaseTemp.showcase.Sweep.Transition[transition],
      })
        .then(() => {
          window.history.replaceState(null, '', this.buildLink(sweepId, rotation));
        })
        .catch((err: any) => {
          console.error(err.toString());
        });
    }
    toast.error('Wait for the model to load');
  };

  moveToStep = async (step: number) => {
    if (this.showCaseTemp) {
      await this.showCaseTemp.showcase.Tour.step(step).catch((err: any) => {
        console.error(err.toString());
      });
    } else {
      toast.error('Wait for the model to load');
    }
  };

  getLogoUrl() {
    const { tour } = this.state;
    return tour && tour?.client ? `${process.env.REACT_APP_AWS}/clients/${tour?.client?.id}/logo.png${all.getVersion(tour.client.updatedAt)}` : '';
  }

  renderMenu() {
    const { tour, room, tokenRemainingTime, whiteLabelData, menuOpen, changeMenu, translation, tourEmail } = this.state;

    return (
      <Menu
        activeMenu={this.state.activeMenu}
        tourMode={tour.mode}
        tourId={tour.id}
        changeMenu={changeMenu}
        menuOpen={menuOpen}
        menuSearch={tour.menuSearch}
        menuCategoryExpand={tour.menuCategoryExpand}
        bookUrl={tour.bookUrl}
        bookText={tour.bookText}
        bookColor={tour.bookColor}
        client={tour.client}
        unbranded={tour.unbranded}
        bookAppointment={tour.appointmentsOn && !room && tokenRemainingTime < 1}
        toggleAppointmentsModal={this.toggleAppointmentsModal}
        contact={tour.contactForm && (tour.client?.phone || tour.client?.email || tourEmail?.contactPhone)}
        whitelabel={whiteLabelData}
        address={tour.address}
        loadModel={this.loadModel}
        moveToMPLabels={this.moveToMPLabels}
        toggleContactPopup={popups.toggleContactPopup.bind(this)}
        toggleExternalPopup={this.toggleExternalPopup.bind(this)}
        translation={translation}
      />
    );
  }

  injectBottomBg() {}

  stopPolygons = async () => {
    try {
      const { polygons } = this.state;

      this.setState({
        polygons: await Promise.all(
          polygons.map(async (item: Polygon) => {
            if (!item.active) return item;
            const nodeIndex = this.modelNodes.findIndex((node: any) => node[0]?.uuid === item.uuid);
            if (nodeIndex >= 0) {
              this.modelNodes[nodeIndex][0].stop();
              item.uuid = null;
              this.modelNodes.splice(nodeIndex, 1);
            }
            return item;
          }),
        ),
      });
    } catch (e) {
      console.error(e);
    }
  };

  toggleVS = async (state?: boolean) => {
    if (!this.vsObjects?.length) return;
    const { isVSEnabled } = this.state;
    if (isVSEnabled) {
      await this.stopVS();
      await this.stopPolygons();
    } else {
      await this.initVS();
      await this.initPolygons();
    }
    this.setState({
      isVSEnabled: !isVSEnabled,
    });
  };

  hideIframeButtons() {
    try {
      if (this.iframe) {
        const iframeButtons = this.iframe?.contentWindow?.document?.querySelector('#bottom-ui');
        if (iframeButtons && iframeButtons.style.display !== 'none') {
          iframeButtons.style.display = 'none';
        }
      }
    } catch (err) {
      console.error(err);
    }
  }

  openVR() {
    const iframeVrButton: any = this.iframe?.contentWindow?.document?.querySelector('.bottom-controls .view-in-vr');
    if (iframeVrButton) iframeVrButton.click();
  }

  getOtherAudio() {
    let audio = !this.tagAudio?.paused ? this.tagAudio : null;
    // added removing sweepAudio on change sweep, removed check paused sweep audio to
    // not miss paused player on sweep change from same audio groups
    if (!audio && this.sweepAudio && !this.sweepAudio.ended) {
      audio = this.sweepAudio;
    }
    if (!audio && !this.polygonAudio?.paused) {
      audio = this.polygonAudio;
    }
    if (!audio && !this.panoramaAudio?.paused) {
      audio = this.panoramaAudio;
    }
    if (!audio && !this.buttonAudio?.paused) {
      audio = this.buttonAudio;
    }
    return audio;
  }

  renderBottomBar(isFullScreen, toggleFullscreen) {
    const {
      tour,
      room,
      sharePopupOn,
      minimapVisible,
      panoramaOn,
      mainPlaying,
      mesurementsOn,
      whiteLabelData,
      reel,
      reelStep,
      translation,
      otherPlaying,
      currentFloor,
      isVSEnabled,
      ticketing,
      mpFloors,
      host,
    } = this.state;

    const audio = this.getOtherAudio();

    const handleSoundControlClose = () => {
      this.setState({
          otherPlaying: false,
      }, () => {
        this.resumeTourMusic();
      });
    };

    return (
      <>
        {otherPlaying && audio && <SoundControls audio={audio} onClose={handleSoundControlClose} />}
        <BottomBar
          host={host}
          allowedTours={ticketing?.ticketingTourTicket?.accessTours}
          showTicketRestrictedAreaPopup={this.showTicketRestrictedAreaPopup}
          onTicketingReel={this.handleTicketingReel}
          audio={this.tourAudio}
          mainPlaying={mainPlaying}
          otherPlaying={otherPlaying}
          toggleSketchfabPopup={this.toggleSketchfabPopup}
          isFull={isFullScreen}
          translation={translation}
          vsObjects={this.vsObjects}
          changeFull={toggleFullscreen}
          openShare={() => {
            this.setState({ sharePopupOn: !sharePopupOn });
          }}
          reelVideos={this.state.reelVideos}
          reel={reel}
          mpFloors={mpFloors}
          room={room}
          loadModel={this.loadModel}
          tour={tour}
          reelStep={reelStep}
          sharePopupOn={sharePopupOn}
          isVSEnabled={isVSEnabled}
          moveToStep={this.moveToStep.bind(this)}
          playTour={this.playTour}
          tourPlaying={this.state.tourPlaying}
          showcase={this.showCaseTemp.showcase}
          changeViewMode={this.changeViewMode}
          mesurementsOn={mesurementsOn}
          panoramaOn={panoramaOn}
          measurementsMode={this.measurementsMode}
          changeFloor={this.changeFloor}
          showPanorama={tour.panorama}
          toggleExternalPopup={this.toggleExternalPopup.bind(this)}
          handleToggleMusic={this.handleToggleMusic.bind(this)}
          takeScreenshot={sdk.takeScreenshot.bind(this)}
          takePano={sdk.takePano.bind(this)}
          whitelabel={whiteLabelData}
          showMinimapClick={() => {
            this.setState({
              minimapVisible: !minimapVisible,
            });
          }}
          showPanoramaClick={this.handleTogglePano}
          onHelpClick={() => {
            this.setState({
              showHelpModal: true,
              showTermsModal: false,
            });
          }}
          onTermsClick={() => {
            this.setState({
              showTermsModal: true,
              showHelpModal: false,
            });
          }}
          toggleVS={this.toggleVS}
          openVR={this.openVR.bind(this)}
          onStartVideo={() => {
            this.setState({ videoPlaying: true });
            this.pauseAllAudio();
          }}
          onStopVideo={() => {
            this.playContainerAudio('tourAudio');
            this.setState({ videoPlaying: false, mainPlaying: true, otherPlaying: false });
          }}
          currentFloor={currentFloor}
          onMuteClick={this.toggleMuteParticipants}
          onFullscreenClick={this.toggleFullscreenVideo}
          onPinClick={this.addPinnedVideo}
          initialDuplicates={this.props?.tourData?.tour?.initialDuplicates}
        />
      </>
    );
  }

  handleTogglePano = async () => {
    const { panoramaOn, showcaseLoaded, room, host, tourPlaying } = this.state;

    if (!panoramaOn && tourPlaying) {
      // We pause the tour if the user wants the pano
      await this.showCaseTemp.showcase.Tour.stop();
    }

    const data = {
      panoramaOn: !panoramaOn,
      activePano: panoramaOn ? null : this.state.activePano,
    };

    if (showcaseLoaded && room && socket && socket.connected && host) {
      socket.emit('toggle-pano', data);
    }

    if (!this.state.lock) {
      this.setState(data);
    }
  };

  injectChildComponents() {}

  /** experience handlers * */

  renderGameContent() {}

  renderGameTourConfig() {}

  hideItemsFromConditions() {}

  renderEndGameScreen(): any {}

  handleGameStart(username: string, skipValidation?: boolean) {}

  tryButtonPlaySound() {}

  /** experience handlers * */

  isRenderAuth() {
    const { tour } = this.state;
    const p = getQueryVariable(window.location.href, 'p');
    if (tour.password && p && atob(decodeURIComponent(p)) === tour.password) return false;
    return tour.password;
  }

  renderAuth() {
    const { tour, whiteLabelData } = this.state;
    return <Login password={tour.password} whitelabel={whiteLabelData} login={all.login.bind(this)} />;
  }

  async pauseAllAudio(type = '', withVsAudio = true) {
    try {
      if (this.tourAudio && type !== 'tourAudio') {
        await this.tourAudio.pause();
      }
      if (this.tagAudio && type !== 'tagAudio') {
        await this.tagAudio.pause();
      }
      if (this.sweepAudio && type !== 'sweepAudio') {
        await this.sweepAudio.pause();
      }
      if (this.polygonAudio && type !== 'polygonAudio') {
        await this.polygonAudio.pause();
      }
      if (this.panoramaAudio && type !== 'panoramaAudio') {
        await this.panoramaAudio.pause();
      }
      if (this.buttonAudio && type !== 'buttonAudio') {
        await this.buttonAudio.pause();
      }

      if (this.state.vsAudio && withVsAudio) {
        this.state.vsAudio.component.toggleMute();
        this.state.vsAudio.btn.setActive(true);
        this.setState({ vsAudio: null });
      }

      this.setState({ mainPlaying: false, otherPlaying: false });
    } catch (e) {}
  }

  createAudioStream(type: string, src: string, clearPrev = false) {
    if (clearPrev && this[type]) {
      this[type].src = '';
    }

    this[type] = new Audio();
    this[type].src = src;
    this[type].autoplay = false;
    this[type].autoplay = false;
    this[type].load();
    return this[type];
  }

  getAudioContainer(type: string) {
    if (this[type]) {
      return this[type];
    }
    return null;
  }

  async playContainerAudio(type: string) {
    if (this[type] && this[type].paused) {
      try {
        await this[type].play();
        return true;
      } catch (error) {
        console.error(error);
        return setTimeout(() => this.playContainerAudio(type), 500);
      }
    }
    await this[type]?.pause();
    return false;
  }

  getShareLocation = () => {
    let location = sdk.getLocation.call(this);

    const { panoramaOn, panoramas } = this.state;
    if (panoramaOn && panoramas?.length > 0 && this.currentPanorama) {
      const pano = `pano=${this.currentPanorama.id}`;
      const panoPitch = `panoPitch=${this.panoPose.pitch}`;
      const panoYaw = `panoYaw=${this.panoPose.yaw}`;
      const panoHfov = `panoHfov=${this.panoPose.hfov}`;

      const query = `${pano}&${panoPitch}&${panoYaw}&${panoHfov}`;
      if (location.split('?')[1]) {
        location += `&${query}`;
      } else {
        location += `?${query}`;
      }
    }

    return location;
  };

  updatePanoRotation = (north: number, pos: any, scene: string) => {
    const { room, host, lock, panoramas } = this.state;
    if (room && socket && socket.connected) {
      if (host) {
        const pano = panoramas.find((p) => p.name === scene);
        if (pano?.id === this.currentPanorama.id) {
          socket.emit('move-pano', {
            panoPose: pos,
            currentPanorama: this.currentPanorama,
          });
        }
        all.updatePanoRotation.call(this, north, pos);
      } else if (!lock) {
        all.updatePanoRotation.call(this, north, pos);
      }
    } else {
      all.updatePanoRotation.call(this, north, pos);
    }
  };

  handlePanoSceneChange = (scene: any) => {
    this.currentPanorama = scene;
    const { room, showcaseLoaded, host } = this.state;
    if (showcaseLoaded && room && socket && socket.connected && host) {
      socket.emit('move-pano', {
        panoPose: {
          pitch: 0,
          yaw: 0,
          hfov: 100,
        },
        currentPanorama: scene,
      });
    }
  };

  handleGameStartOnIntroModal = (username: string) => {
    this.handleGameStart(username, true);
  };

  addAvatar = async (data: any) => {
    // calculating new position based on new center
    const [myX, myZ] = pointsOnCircle2D(AVATAR_CIRCLE_RADIUS, 180 + this.avatarDegree, data?.pose?.position?.x, data?.pose?.position?.z);
    const [x, z] = pointsOnCircle2D(AVATAR_CIRCLE_RADIUS, data.degree, myX, myZ);
    console.log('Adding avatar', data.name);
    await this.onAddAvatar(
      new Avatar({
        uuid: data.avatarId,
        name: data.name,
        url: data.avatarUrl,
        positionX: x,
        positionY: data.pose?.position?.y,
        positionZ: z,
        rotationX: data.pose?.rotation?._x,
        rotationY: data.pose?.rotation?._y,
        rotationZ: data.pose?.rotation?._z,
        quaternionX: data.pose?.quaternion?._x,
        quaternionY: data.pose?.quaternion?._y,
        quaternionZ: data.pose?.quaternion?._z,
        quaternionW: data.pose?.quaternion?._w,
        degree: data.degree,
      }),
    );
  };

  onAddAvatar = async (data: Avatar) => {
    if (!this.avatarNodes.has(data.uuid)) {
      if (!data.positionX && !data.positionY && !data.positionZ) {
        data.positionX = this.pose.position.x;
        data.positionY = this.pose.position.y;
        data.positionZ = this.pose.position.z;
      }
      // TODO: implement LoadingQueue
      const avatarNode = await this.initAvatarNode(data);

      avatarNode[0].obj3D.position.set(data.positionX, data.positionY, data.positionZ);
      avatarNode[0].obj3D.rotation.set(data.rotationX, data.rotationY, data.rotationZ);
      avatarNode[0].obj3D.quaternion.set(data.quaternionX, data.quaternionY, data.quaternionZ, data.quaternionW);
      avatarNode[0].obj3D.children[0]?.rotation.set(0, Math.PI, 0);
      if (avatarNode?.length) {
        if (!data?.muted) {
          if (avatarNode[2]) {
            // changing state to !active if video is not muted
            avatarNode[2].setActive(!avatarNode[2].isActive());
          }
        }
        this.avatarNodes.set(data.uuid, avatarNode);
      }
      return avatarNode;
    }
  };

  onRemoveAvatar = async (uuid: string) => {
    if (this.avatarNodes.size) {
      const [avatar] = this.avatarNodes.get(uuid);
      if (avatar) {
        avatar.stop();
        this.avatarNodes.delete(uuid);
      }
    }
  };

  videoEndCall = () => {
    socket.removeAllListeners();
    socket.close();
    this.setState({ room: null, reelVideos: [] });
  };

  videoChangeTour = (data: any) => {
    const { tour } = this.state;
    const m = getQueryVariable(this.state.iframeUrl, 'm');
    if (data.id && data.id !== m) {
      if (data.mp) {
        this.moveModel(`/mp-sdk/${process.env.REACT_APP_SDK_VERSION}/showcase.html?applicationKey=${tour?.user?.mpSDK}&m=${data.id}`);
      } else {
        this.getTour({ id: data.id, changeMenu: false, changeMinimap: true, changePanorama: false });
      }
    }
  };

  changeMuteStatus = (name: string, muted: boolean) => {
    const { fullscreenVideo, pinnedVideos, reelVideos } = this.state;
    const isReeled = reelVideos.findIndex((i) => i.name === name);
    const isPinned = pinnedVideos.findIndex((i) => i.name === name);
    const isFullscreen = fullscreenVideo?.name === name;

    if (isFullscreen) {
      fullscreenVideo.muted = muted;
    } else if (isPinned >= 0) {
      pinnedVideos[isPinned].muted = muted;
      this.addPinnedVideo(pinnedVideos[isPinned]);
    } else if (isReeled >= 0) {
      reelVideos[isReeled].muted = muted;
      this.addVideoReel(reelVideos[isReeled]);
    }
  };

  addTrack = async (p: any) => {
    try {
      const { fullscreenVideo, pinnedVideos } = this.state;
      if (p.track?.kind === 'audio' && !p.self) {
        const audioEl = new Audio();
        audioEl.append(p.track.attach());
        audioEl.setAttribute('data-cy-audio-track-name', p.track.name);
        audioEl.setAttribute('data-cy-audio-track-sid', p.sid);
        document.body.appendChild(audioEl);
        if (!p.enabled) {
          audioEl.pause();
          this.changeMuteStatus(p.name, true);
        } else {
          this.changeMuteStatus(p.name, false);
        }
      } else if (p.track?.kind === 'video') {
        const isFullscreen = fullscreenVideo?.sid === p.sid;
        const isPinned = pinnedVideos.findIndex((i) => i.sid === p.sid);
        if (p.dominant) {
          this.setState({ dominantSpeaker: p });
        } else if (isFullscreen) {
          this.setState({ fullscreenVideo: p });
        } else if (isPinned >= 0) {
          // || p.track.name.includes('-screen')
          // we pin screen shares
          this.addPinnedVideo(p);
        } else {
          this.addVideoReel(p);
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  removeTrack = async (sid: string) => {
    try {
      const { fullscreenVideo, pinnedVideos, audioOnly } = this.state;
      const isFullscreen = fullscreenVideo?.sid === sid;
      const isPinned = pinnedVideos.findIndex((i) => i.sid === sid);
      if (isFullscreen) {
        this.setState({ fullscreenVideo: null });
      } else if (isPinned >= 0) {
        this.removePinnedVideo(sid);
        if (audioOnly) this.removePinnedVideo(`${sid}_video`);
      } else {
        this.removeVideoReel(sid);
        if (audioOnly) this.removeVideoReel(`${sid}_video`);
      }
    } catch (e) {
      console.error(e);
    }
  };

  addVideoReel = async (p: any) => {
    try {
      if (p.track?.kind === 'video') {
        const reelVideos = [...this.state.reelVideos];
        const index = reelVideos.findIndex((i) => i.sid === p.sid);
        if (index >= 0) {
          reelVideos[index] = p;
        } else {
          reelVideos.push(p);
        }
        this.setState({ reelVideos });
      }
    } catch (e) {
      console.error(e);
    }
  };

  removeVideoReel = async (sid: string) => {
    console.log(`Removing ${sid} from reel`);
    this.setState({
      reelVideos: this.state.reelVideos.filter((i) => i.sid !== sid),
    });
  };

  addPinnedVideo = async (p: any) => {
    addPinnedVideoFunc(p, this.state.pinnedVideos, (pinnedVideos) => {
      this.setState({ pinnedVideos }, () => {
        if (!p.pinned) this.removeVideoReel(p.sid);
      });
    });
  };

  removePinnedVideo = async (sid: string) => {
    this.setState({
      pinnedVideos: this.state.pinnedVideos.filter((i) => i.sid !== sid),
    });
  };

  toggleFullscreenVideo = async (participant: any, pinned = false) => {
    const { fullscreenVideo } = this.state;
    if (fullscreenVideo?.sid === participant.sid) {
      // close fullscreen video
      if (fullscreenVideo.pinned) {
        this.addPinnedVideo(fullscreenVideo);
      } else {
        this.addVideoReel(fullscreenVideo);
      }
      this.setState({ fullscreenVideo: null });
      document.removeEventListener('keydown', this.exitFullscreenVideo);
    } else {
      // open fullscreen video
      if (fullscreenVideo) {
        // first close old one, then add the new one
        if (fullscreenVideo.pinned) {
          this.addPinnedVideo(fullscreenVideo);
        } else {
          this.addVideoReel(fullscreenVideo);
        }
      }
      this.setState({ fullscreenVideo: { ...participant, pinned } });
      this.removePinnedVideo(participant.sid);
      this.removeVideoReel(participant.sid);
      document.addEventListener('keydown', this.exitFullscreenVideo);
    }
  };

  exitFullscreenVideo = (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      if (this.state.fullscreenVideo) {
        this.toggleFullscreenVideo(this.state.fullscreenVideo);
      }
    }
  };

  initAvatar = async () => {
    const { tour } = this.state;
    if (!tour.enableAvatar) return;

    try {
      const avatar = undefined; // storage('avatar').get();
      if (!avatar) {
        this.setState({ avatar: null, chatParticipant: null });
      } else {
        await this.setAvatar(avatar);
      }
    } catch (e) {}
  };

  toggleMuteParticipants = async (sid: string) => {
    const audioEl: any = document.querySelectorAll(`[data-cy-audio-track-sid=${sid}]`);
    let mute = false;
    if (audioEl && audioEl.length > 0) {
      if (audioEl[0].playing) {
        audioEl[0].pause();
        mute = true;
      } else {
        audioEl[0].play();
        mute = false;
      }
      if (this.state.host) {
        socket.emit('mute_participant', {
          participantId: sid,
          mute,
        });
      }
    }
  };

  setAvatar = async (data) => {
    const { tour, room } = this.state;
    this.setState({ chatParticipant: data });
    console.log('Avatars enabled?', tour.enableAvatar);
    if (!tour.enableAvatar) return;

    const avatarId = uuid();
    const avatar = {
      ...data,
      uuid: avatarId,
    };
    // storage('avatar').set(avatar);
    this.setState({ avatar });
    console.log(`Joining avatar to room ${room}`);
    socket.emit('user_joining', {
      name: data.name,
      room: room || tour.id,
      avatarUrl: data.url,
      avatarId,
      model: data.model,
      pose: {
        rotation: this.camera?.camera.rotation,
        quaternion: this.camera?.camera.quaternion,
        position: this.pose.position,
      },
      sweep: this.pose.sweep,
    });
  };

  toggleSketchfabPopup = (state: boolean) => () => {
    this.setState({ showSketchfabPopup: state });
  };

  onCloseIntro = () => {
    const { tour, tourType } = this.state;

    if (tourType === TourType.Game) {
      this.setState({ showIntro: false }, () => {
        if (tour?.autoplayMusic) this.playAudio();
      });
    } else {
      this.setState({ showIntro: false, forcePlayGameIntro: true }, () => {
        this.processTourMusic(tour);
      });
    }
  };

  getCurrentLanguage = () => {
    const pathnameSplitted = window.location.pathname.split('/');
    const currentSlug = pathnameSplitted[pathnameSplitted.length - 1];
    return this.state.initialDuplicates?.find((duplicate: any) => duplicate.slug === currentSlug);
  };

  unlockChapter = (targetObj: any, type: ChapterType): void => {
    const {
      game: { book, gameBookOn },
      unlockedChapterIds,
      clickedElements,
    } = this.state;
    let value = targetObj?.details?.id;
    if (type === ChapterType.Tag || type === ChapterType.Polygon) {
      value = targetObj?.id;
    }

    this.setState({
      clickedElements: [
        ...clickedElements,
        {
          type,
          value,
        },
      ],
    });

    if (!gameBookOn || !book) return;

    const chapters = sortBy(book?.chapters, 'order');
    const chapter = chapters.find((item) => item.order === unlockedChapterIds.length + 1);

    let unblock = false;
    switch (type) {
      case ChapterType.Tag: {
        const tag = targetObj as Tag;
        unblock = chapter && chapter.type === ChapterType.Tag && (chapter.value === String(tag.id) || chapter.value === tag.sid);
        break;
      }
      case ChapterType.Polygon:
        const polygon = targetObj as Polygon;
        unblock = chapter && chapter.type === ChapterType.Polygon && chapter.value === String(polygon.id);
        break;
      case ChapterType.VSItem:
        const vsItem = targetObj.details as VSObject;
        unblock = chapter && chapter.type === ChapterType.VSItem && chapter.value === String(vsItem.id);
        break;
      case ChapterType.VSImage:
        const vsImage = targetObj.details as VSImage;
        unblock = chapter && chapter.type === ChapterType.VSImage && chapter.value === String(vsImage.id);
        break;
      case ChapterType.VSVideo:
        const vsVideo = targetObj.details as VSVideo;
        unblock = chapter && chapter.type === ChapterType.VSVideo && chapter.value === String(vsVideo.id);
        break;
      default:
        break;
    }

    if (unblock) {
      this.tryButtonPlaySound();
      this.setState({
        unlockedChapterIds: [...unlockedChapterIds, chapter.id],
      });
    }
  };

  public render() {
    const {
      tour,
      game,
      sweepGroups,
      mesurementsOn,
      allowGuestBeforeHost,
      room,
      activeSweepGroup,
      sharePopupOn,
      overlayOn,
      showcaseLoaded,
      tokenRemainingTime,
      tokenExpiresAt,
      showSketchfabPopup,
      whiteLabelData,
      minimapVisible,
      minimapOn,
      minimaps,
      selectedMinimap,
      mapWalkerX,
      mapWalkerY,
      mapWalkerRotation,
      lock,
      tagPopOn,
      panoPopOn,
      openedTag,
      openedPanoHotspot,
      vsActionPopOn,
      openedVSAction,
      contactPopupOn,
      externalPopupOn,
      externalPopupUrl,
      panoramaOn,
      host,
      selectedMarker,
      showHelpModal,
      showTermsModal,
      showCollectLeadsModal,
      panoramas,
      interacted,
      showIntroScreen,
      showIntro, // game intro clip
      containerId,
      loadingTags,
      agents,
      tourEmail,
      translation,
      tourType,
      reelVideos,
      experiencePopUpIsOpen,
      initialDuplicates,
      experiencePopUpData,
      forcePlayGameIntro,

      // --- to add
      ticketingOpen,
      ticketing,
      avatar,
      chatParticipant,
      iframeUrl,
      audioOnly,
    } = this.state;
    const { _tour, tourImage } = this.props;
    const preview = !!_tour;
    const loadSweeps = !showIntro && !showIntroScreen && !loadingTags && showcaseLoaded && sweepGroups && sweepGroups.length > 0;
    const isGameTour = tourType === TourType.Game;
    const showGameWatermark = isGameTour && game && tour && !game.paid && tour.userId !== 1;
    const showTicketWatermark = tourType !== TourType.ECommerce && tour?.ticket && !ticketing?.ticketingGeneral?.paid;
    const showEcommerceWatermark = tourType === TourType.ECommerce && !tour?.ecommercePaidStatus;

    let ticketingContentTickets = [];
    if (ticketing?.ticketingOrderedTicket?.ticketType === 'tourByYourself') ticketingContentTickets = ticketing?.ticketingToursByYourself;
    else if (ticketing?.ticketingOrderedTicket?.ticketType === 'gameTour') ticketingContentTickets = ticketing?.ticketingGameTour;
    else if (ticketing?.ticketingOrderedTicket?.ticketType === 'guidedTour') ticketingContentTickets = ticketing?.ticketingGuidedTour;
    return (
      <FullScreen attrs={{ id: 'global-fullscreen' }} rootBody>
        {({ isFullScreen, toggleFullscreen }) => (
          <>
            {!ticketingOpen && !showIntroScreen && !showCollectLeadsModal && this.state.tourType !== TourType.Game && !this.isRenderAuth() && !this.state.loaded && (
              <div className="intro-screen" style={{ backgroundImage: `url(${process.env.REACT_APP_AWS}/tours/${this.state.tour?.id}/images/${this.state.tour?.mainImage})` }}>
                <h1 style={{ marginTop: '100px', fontSize: '50px' }}>{tour?.title}</h1>
                <span className="shadow" />
                <LoadingProgress showSpinner showBar={false} />
              </div>
            )}
            {this.state.gameTrialErr && this.state.tourType === TourType.Game && (
              <div className="gameTrialErr">
                <div className="gameTrialErr-text">{this.state.gameTrialErr}</div>
                <Button onClick={() => window.close()}>Close</Button>
              </div>
            )}
            {experiencePopUpIsOpen && (
              <ExperiencePopUp
                onInit={() => {
                  if (this.state.tourType === TourType.Game) {
                    this.pauseTourMusic();
                  } else {
                    this.pauseAllAudio();
                  }
                }}
                tourId={tour?.id}
                logo={whiteLabelData?.logo}
                initialDuplicates={initialDuplicates}
                tryButtonPlaySound={this.tryButtonPlaySound}
                experiencePopUpData={experiencePopUpData}
                isOpen={experiencePopUpIsOpen}
                translations={translation}
                setIsOpen={(status) => {
                  // as I understand this using only for closing experience from itself
                  if (this.state.tourMusicWasPaused) {
                    this.resumeTourMusic();
                  }
                  this.state.onExperienceCloseCallback();
                  this.setState({
                    tourMusicWasPaused: false,
                    experiencePopUpIsOpen: status,
                    closedElementPopup: !status,
                    onExperienceCloseCallback: () => undefined,
                  });
                }}
              />
            )}
            {showcaseLoaded && (showGameWatermark || showTicketWatermark || showEcommerceWatermark) && (
              <Watermark show={showcaseLoaded && (showGameWatermark || showTicketWatermark || showEcommerceWatermark)} id="game-watermark">
                <p>Demo</p>
              </Watermark>
            )}
            {ticketingOpen && (
              <TicketingRouter
                matterId={tour.slug}
                parentTourId={tour.parentId}
                tourId={tour.id}
                gameId={tour.gameId}
                ticketing={ticketing}
                reactAppDomain={this.root}
                reactAws={this.props.reactAws}
                tourImage={tourImage}
                onTicketLoginSuccess={this.onTicketLoginSuccess}
                translation={translation}
                whiteLabelData={whiteLabelData}
              />
            )}
            {!ticketingOpen && showIntroScreen && tour && !tour.password && this.state.tourType !== TourType.Game && (
              <IntroScreen
                tour={tour}
                introScreen={tour.introScreen}
                showcaseLoaded={showcaseLoaded}
                vsObjectsLength={this.vsObjects.length}
                whiteLabelData={whiteLabelData}
                onPlayClick={this.onPlayClick}
              />
            )}

            <div
              id={`${containerId}-tour-root`}
              className={classnames(preview ? 'preview base-tour tour-container' : 'base-tour tour-container', DeviceManager.isMobile() && 'no-visible-scrollbar')}
              // eslint-disable-next-line no-return-assign
              ref={(el) => (this.root = el)}
            >
              {tokenRemainingTime > 0 && (
                <div className="countDownWrap">
                  <div className="countDown">
                    <Countdown
                      date={tokenExpiresAt}
                      zeroPadDays={0}
                      onComplete={() => {
                        this.props.history.push('/');
                      }}
                    />
                  </div>
                </div>
              )}

              {showCollectLeadsModal && <CollectLeadsForm tour={tour} rtl={tour.client?.rtl} translation={translation} onStart={this.handleCollectLeadsSubmit} />}

              {!ticketingOpen && tour && (
                <div>
                  {this.isRenderAuth() ? (
                    this.renderAuth()
                  ) : (
                    <div className={classnames('inner', DeviceManager.isMobile() && 'mobile')} style={showCollectLeadsModal && tour.mainImage ? { backgroundColor: '#000' } : {}}>
                      {tour.messengerLink && tour.messengerGreeting && this.messenger !== 0 && !room && (
                        <MessengerCustomerChat
                          pageId={tour.messengerLink}
                          appId="741048509750318"
                          loggedInGreeting={tour.messengerGreeting}
                          loggedOutGreeting={tour.messengerGreeting}
                          themeColor={whiteLabelData?.secondaryColor || '#ea475c'}
                          shouldShowDialog
                          version="7.0"
                        />
                      )}
                      {externalPopupUrl && externalPopupOn && (
                        <ExternalPopup
                          show={externalPopupUrl && externalPopupOn}
                          url={externalPopupUrl}
                          onClose={this.toggleExternalPopup.bind(this, null)}
                          logo={whiteLabelData?.logo}
                        />
                      )}

                      {this.injectChildComponents()}

                      {!isGameTour && tour.gameId && (
                        <RegularPaths
                          gameId={tour.gameId}
                          allTags={this.state.allTags}
                          modelNodes={this.modelNodes}
                          polygons={this.state.polygons}
                          showcase={this.showCaseTemp}
                          vsObjects={this.vsObjects}
                          sweeps={this.state.sweeps}
                          clickedElement={this.state.clickedElement}
                        />
                      )}

                      {tagPopOn && <TagsPopup logo={whiteLabelData?.logo} obj={openedTag} type="tags" tourId={tour.id} closePop={this.closeTagPop} />}

                      {!ticketingOpen && ticketing?.ticketingOrderedTicket && (
                        <RenderTicketingContent
                          tickets={ticketingContentTickets}
                          translation={ticketing?.ticketingTranslation}
                          tourSlug={tour.slug}
                          ticketingOrderedTicket={ticketing?.ticketingOrderedTicket}
                          ticketTimeLeftMs={this.state.ticketTimeLeftMs}
                          ticketModalInfo={this.state.ticketModalInfo}
                          root={this.root}
                          tourId={tour.id}
                          gameId={tour.gameId}
                          ticketingGeneral={ticketing?.ticketingGeneral}
                          showTicketModal={this.state.showTicketModal}
                        />
                      )}

                      {openedPanoHotspot && panoPopOn && <PanoPopup hotspot={openedPanoHotspot} show={panoPopOn} onClose={this.closePanoPop} logo={whiteLabelData?.logo} />}
                      {this.state.showPathFinderPopup && <PathFinderPopup open={this.state.showPathFinderPopup} closePopup={this.closePathFinderPop} />}

                      {vsActionPopOn && <VSActionsPopup tourId={tour.id} object={openedVSAction} onClose={this.closeActionPop} />}

                      {contactPopupOn && showcaseLoaded && (
                        <ContactPopup
                          agents={agents}
                          rtl={tour.client?.rtl}
                          translation={translation}
                          to={tourEmail?.menuGetInTouch || tour?.client?.email}
                          legalBookingBox={tour.legalBookingBox}
                          legalBookingBox2={tour.legalBookingBox2}
                          userId={tour.userId}
                          tourId={tour.id}
                          title={tour.title}
                          client={tour.client}
                          hideClientContact={tour.hideClientContact}
                          phone={tourEmail?.contactPhone}
                          name={tourEmail?.contactName}
                          toggleContactPopup={popups.toggleContactPopup.bind(this)}
                        />
                      )}

                      {tour.qualtricsId && showcaseLoaded && (
                        <Qualtrics
                          onClick={() => {
                            const { tour } = this.state;
                            tour.qualtricsId = null;
                            this.setState({ tour });
                          }}
                          qualtricsId={tour.qualtricsId}
                          onKeyPress={() => {}}
                        />
                      )}

                      {!room && (
                        <Ad
                          time={tour.adTime}
                          res={DeviceManager.isMobile() ? tour.adResMobile : tour.adRes}
                          width={DeviceManager.isMobile() ? tour.adWidthMobile : tour.adWidth}
                          height={DeviceManager.isMobile() ? tour.adHeightMobile : tour.adHeight}
                          tourId={tour.id}
                          matterId={tour.matterId}
                          to={(tourEmail && tourEmail.leadForms) || (tour.client && tour.client.email)}
                          rtl={tour.client?.rtl}
                          updatedAt={tour.updatedAt}
                          enabled={tour.ad}
                          url={tour.adUrl}
                          leads={tour.adLeads}
                          userId={tour.userId}
                          clientId={tour.clientId}
                          translation={translation}
                          legalBookingBox={tour.legalBookingBox}
                          legalBookingBox2={tour.legalBookingBox2}
                          leadsPhone={tour.leadsPhone}
                        />
                      )}

                      {!isGameTour && panoramaOn && panoramas?.length > 0 && (
                        <Panorama
                          panoramas={panoramas}
                          markMinimap={this.markMinimap}
                          panoPose={this.state.panoPose}
                          activePano={this.state.activePano}
                          transition={tour.panoramaTransition}
                          isChatGuest={room && socket && socket.connected && !host}
                          defaultPanorama={tour.defaultPanorama}
                          updatePanoRotation={this.updatePanoRotation}
                          openHotspot={sdk.openedPanoHotspot.bind(this)}
                          onSceneChange={this.handlePanoSceneChange}
                        />
                      )}

                      <div className={`overlay ${overlayOn ? 'open' : ''}`} />
                      {tour.menuEnabled &&
                        tourType !== TourType.Game &&
                        showcaseLoaded &&
                        !(mesurementsOn && !!(DeviceManager.isMobile() ? tour.menuAlwaysOpenMobile : tour.menuAlwaysOpenDesktop)) &&
                        this.renderMenu()}

                      {room && this.showCaseTemp && this.pose && (
                        <MemoizedVideo
                          sdk={this.showCaseTemp.showcase}
                          tour={tour}
                          host={host}
                          audioOnly={audioOnly}
                          measurementsOn={mesurementsOn}
                          room={room}
                          slug={tour.slug}
                          name={chatParticipant?.name}
                          avatar={chatParticipant}
                          reelVideos={reelVideos}
                          endCall={this.videoEndCall}
                          clientId={tour.clientId}
                          tourId={tour.id}
                          enterprise={tour?.user?.enterprise}
                          translation={translation}
                          allowGuestBeforeHost={allowGuestBeforeHost}
                          changeTour={this.videoChangeTour}
                          addTrack={this.addTrack}
                          removeTrack={this.removeTrack}
                          pinnedVideos={this.state.pinnedVideos}
                          removePinnedVideo={this.removePinnedVideo}
                          onToggleMute={this.toggleMuteParticipants}
                          onToggleFullscreen={this.toggleFullscreenVideo}
                          dominantSpeaker={this.state.dominantSpeaker}
                          fullscreenVideo={this.state.fullscreenVideo}
                          addVideoReel={this.addVideoReel}
                        />
                      )}

                      {this.showCaseTemp && (!avatar || (room && !tour?.enableAvatar && !chatParticipant.name?.length)) && (
                        <div id="video-name-overlay" className="overlay">
                          <IntroPopup
                            sdk={this.showCaseTemp.showcase}
                            enableAvatar={tour?.enableAvatar}
                            translation={translation}
                            showVideoCameraCheckbox
                            room={room}
                            onSubmit={this.setAvatar}
                          />
                        </div>
                      )}

                      {tour.legalNote && (
                        <p
                          className={`legal-note ${tour.client && tour.client.rtl && 'rtl'}`}
                          // eslint-disable-next-line react/no-danger
                          dangerouslySetInnerHTML={{
                            // eslint-disable-next-line no-control-regex
                            __html: tour.legalNote.replace(new RegExp('\r?\n', 'g'), '<br />'),
                          }}
                        />
                      )}

                      {showcaseLoaded && !tour.unbranded && tour.client && tour.client.logo && !room && (
                        <a
                          href={tour.client?.website ? (tour.client.website?.includes('https://') ? tour.client.website : `https://${tour.client.website}`) : ''}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            className={tour.client.widthLogo ? 'logo width' : 'logo'}
                            src={`${process.env.REACT_APP_AWS}/clients/${tour.client.id}/logo.png${all.getVersion(tour.client.updatedAt)}`}
                            alt=""
                          />
                        </a>
                      )}

                      {showcaseLoaded && this.renderButtonBg()}

                      {this.state.markerPopupOn && (
                        <div className="popup">
                          <button
                            className="btn"
                            onClick={() => {
                              this.setState({
                                overlayOn: false,
                                markerPopupOn: false,
                              });
                            }}
                          >
                            <i className="fas fa-times" />
                          </button>

                          <h4>What do you want to do?</h4>
                          <a onClick={this.toggleExternalPopup.bind(this, this.state.selectedMarker.external)}>Open Autodesk Viewer</a>
                          <a onClick={() => this.moveModel(selectedMarker.url)}>Move to this point</a>
                        </div>
                      )}

                      {showcaseLoaded && (
                        <Minimap
                          tour={tour}
                          minimapOn={minimapOn}
                          minimapVisible={minimapVisible}
                          minimaps={minimaps}
                          selectedMinimap={selectedMinimap}
                          mapWalkerX={mapWalkerX}
                          mapWalkerY={mapWalkerY}
                          mapWalkerRotation={mapWalkerRotation}
                          markerClick={this.markerClick}
                          onClick={() => {
                            this.setState({ minimapOn: !minimapOn });
                          }}
                        />
                      )}
                      {this.state.appointmentsModal && (
                        <Appointment
                          tour={tour}
                          translation={translation}
                          tourEmail={tourEmail}
                          rtl={tour.client && tour.client.rtl}
                          appointmentsModal={this.state.appointmentsModal}
                          toggleAppointmentsModal={this.toggleAppointmentsModal}
                          appointmentTime={tour.appointmentTime}
                        />
                      )}

                      {sharePopupOn && (
                        <Share
                          getLocation={this.getShareLocation}
                          onClose={() => {
                            this.setState({
                              sharePopupOn: false,
                            });
                          }}
                          copyToClipboard={all.copyToClipboard}
                          translation={translation}
                          onColor={whiteLabelData?.secondaryColor || '#ea475c'}
                        />
                      )}
                      {showcaseLoaded && !(window.innerWidth < 1024 && mesurementsOn) && this.renderBottomBar(isFullScreen, toggleFullscreen)}

                      {loadSweeps && (
                        <Sweep
                          clearSweepAudio={() => {
                            if (this.sweepAudio) this.sweepAudio.pause();
                            this.sweepAudio = null;
                          }}
                          audioContainer={{
                            audio: this.sweepAudio,
                            createAudioStream: this.createAudioStream.bind(this),
                            pause: () => {
                              this.sweepAudio?.pause();
                              this.setState({ otherPlaying: false });
                            },
                            play: () => {
                              this.playContainerAudio('sweepAudio');
                              this.setState({ mainPlaying: false, otherPlaying: true });
                            },
                            pauseAllAudio: async () => {
                              await this.pauseAllAudio('sweepAudio');
                              this.setState({ mainPlaying: false, otherPlaying: true });
                            },
                          }}
                          videoContainer={{
                            pause: this.pauseTourMusic,
                            play: this.resumeTourMusic,
                          }}
                          title={tour.title}
                          client={tour.client}
                          legalBookingBox={tour.legalBookingBox}
                          legalBookingBox2={tour.legalBookingBox2}
                          panoramaStart={panoramaOn}
                          userId={tour.userId}
                          tourId={tour.id}
                          email={(tourEmail && tourEmail.leadSweeps) || (tour.client && tour.client.email)}
                          groups={sweepGroups}
                          selectedGroup={activeSweepGroup}
                          noAudioMode={tour.noAudioMode && room}
                          translation={translation}
                          showPanoramaClick={(panoramaId: number) => {
                            const pIndex = panoramas.findIndex((p: any) => p.id === panoramaId);
                            panoramas[pIndex].default = true;
                            this.setState({
                              panoramas,
                              panoramaOn: !panoramaOn,
                            });
                          }}
                          onInteractedChange={(interacted: boolean) => {
                            this.setState({ interacted });
                          }}
                          logo={whiteLabelData?.logo}
                        />
                      )}

                      {showHelpModal && (
                        <Help
                          translation={translation}
                          onClose={() => {
                            this.setState({
                              showHelpModal: false,
                            });
                          }}
                        />
                      )}

                      {showTermsModal && (
                        <Terms
                          translation={translation}
                          tourId={tour.id}
                          onClose={() => {
                            this.setState({
                              showTermsModal: false,
                            });
                          }}
                        />
                      )}

                      {lock && <div className="lock-layer" />}

                      {showcaseLoaded && ((tour.music && tour.autoplayMusic) || activeSweepGroup) && !room && !interacted && (
                        <div
                          id="music-cover"
                          style={{
                            zIndex: 2,
                            position: 'fixed',
                            height: '100vh',
                            width: '100vw',
                            top: 0,
                            left: 0,
                          }}
                        />
                      )}

                      <LoadTourIframe
                        iframeId={this.state.iframeId}
                        mesurementsOn={mesurementsOn}
                        iframeStyle={getIframeStyle({
                          tour: this.state.tour,
                          activeSweepGroup: this.state.activeSweepGroup,
                          sweepGroups: this.state.sweepGroups,
                        })}
                        cb={(el) => {
                          this.iframe = el;
                          this.hideIframeButtons();
                        }}
                        iframeUrl={iframeUrl}
                        isFullScreen={isFullScreen}
                      />
                      {showIntro && !showIntroScreen ? (
                        <ClipScreen
                          videoUrl={game?.introClipUrl || ''}
                          close={() => {
                            this.onCloseIntro();
                          }}
                          forcePlay={forcePlayGameIntro}
                          subtitles={this.getCurrentLanguage()?.languageCode}
                          onStartEvent={() => {}}
                        />
                      ) : (
                        this.renderGameContent()
                      )}
                      {!isGameTour && game?.book && (
                        <GameBookHandle
                          gameBook={game.book}
                          onToggleGameBookModal={() => this.setState((state) => ({ showBook: !state.showBook }))}
                          showBook={this.state.showBook}
                          closeGameBook={() => this.setState({ showBook: false })}
                          unlockedChapterIds={this.state.unlockedChapterIds}
                          tryButtonPlaySound={this.tryButtonPlaySound}
                          moveToSweep={this.moveToSweep}
                          hideBook={!game?.gameBookOn || !game?.book || this.state.showBook}
                        />
                      )}
                      {this.renderGameTourConfig()}
                    </div>
                  )}
                </div>
              )}
            </div>

            {tour && !tour.hideCookie && (
              <CustomCookieConsent
                tour={tour}
                loaded={showcaseLoaded}
                message={tour && translation?.cookieConsentText}
                accept={tour && translation?.cookieConsentAccept}
                decline={tour && translation?.cookieConsentDecline}
              />
            )}
            {showSketchfabPopup && <SketchfabPopup show={showSketchfabPopup} vsObjects={this.vsObjects} onClose={this.toggleSketchfabPopup(false)} />}
            <SetDataToRecoil translation={translation} rtl={tour?.client?.rtl} />
            {this.renderCrashScreen()}
          </>
        )}
      </FullScreen>
    );
  }
}
